(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _router = require("./router");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
Promise.resolve().then(function () {
  return _interopRequireWildcard(require("./backwardCompatibility"));
});
Promise.resolve().then(function () {
  return _interopRequireWildcard(require("./common/jqueryPlugins"));
});
(0, _router.router)();

},{"./backwardCompatibility":2,"./common/jqueryPlugins":5,"./router":29}],2:[function(require,module,exports){
(function (global){(function (){
"use strict";

var _compatibilityHelpers = require("./common/compatibilityHelpers");
var _userProfile = _interopRequireDefault(require("./models/userProfile"));
var _cfs = _interopRequireDefault(require("./services/api/cfs"));
var _cli = _interopRequireDefault(require("./services/api/cli"));
var _configuration = _interopRequireDefault(require("./services/api/configuration"));
var _dataset = _interopRequireDefault(require("./services/api/dataset"));
var _generalConfiguration = _interopRequireDefault(require("./services/api/generalConfiguration"));
var _unit = _interopRequireDefault(require("./services/api/unit"));
var _user = _interopRequireDefault(require("./services/api/user"));
var _navigator = _interopRequireDefault(require("./router/navigator"));
var _auth = _interopRequireDefault(require("./services/auth"));
var _rapidSOS = _interopRequireDefault(require("./services/api/rapidSOS"));
var _batchPrintModal = _interopRequireDefault(require("./components/batchPrintModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

global.datasetApi = _dataset["default"];
global.configurationApi = _configuration["default"];
global.generalConfigurationApi = _generalConfiguration["default"];
global.cfsApi = _cfs["default"];
global.unitApi = _unit["default"];
global.cliApi = _cli["default"];
global.userProfile = _userProfile["default"];
global.remapField = _compatibilityHelpers.remapField;
global.auth = _auth["default"];
global.userApi = _user["default"];
global.navigate = _navigator["default"];
global.rapidApi = _rapidSOS["default"];
global.batchPrint = _batchPrintModal["default"];

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./common/compatibilityHelpers":3,"./components/batchPrintModal":8,"./models/userProfile":17,"./router/navigator":30,"./services/api/cfs":32,"./services/api/cli":33,"./services/api/configuration":35,"./services/api/dataset":37,"./services/api/generalConfiguration":38,"./services/api/rapidSOS":43,"./services/api/unit":46,"./services/api/user":47,"./services/auth":48}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remapField = void 0;

var remapField = exports.remapField = function remapField(object, map) {
  for (var oldFieldKey in map) {
    var newFieldKey = map[oldFieldKey];
    if (typeof newFieldKey === "string" && oldFieldKey !== newFieldKey) {
      object[oldFieldKey] = object[newFieldKey];
    } else if (typeof newFieldKey === "function") {
      object[oldFieldKey] = newFieldKey(object);
    }
  }
};

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowType = exports.UserRole = exports.PoliceCallTypeStatus = exports.AgencyType = exports.API_LIST_ALL_LENGTH = void 0;
var UserRole = exports.UserRole = {
  SUPER_ADMIN: "SuperAdmin",
  ORG_ADMIN: "OrganizationAdmin",
  ORG_USER: "OrganizationUser",
  ORG_SUPERVISOR: "OrganizationSupervisor"
};
var WindowType = exports.WindowType = {
  CLI: "CLI",
  CFS: "CFS",
  POLICE: "Police",
  FIRE: "Fire"
};
var API_LIST_ALL_LENGTH = exports.API_LIST_ALL_LENGTH = Math.pow(10, 9);
var AgencyType = exports.AgencyType = {
  Police: 1,
  Fire: 2
};
var PoliceCallTypeStatus = exports.PoliceCallTypeStatus = {
  One: "1",
  Two: "2",
  Three: "3",
  Four: "4",
  Five: "5",
  Advised: "ADVISED"
};

},{}],5:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function ($) {
  $.datetimepicker.setDateFormatter("moment");
  $.isDate = function (obj) {
    return obj instanceof Date && obj.toString() !== "Invalid Date";
  };

  $.fn.extend({
    loading: function loading(isLoading, text) {
      return this.each(function () {
        $(this).button({
          loadingText: text || "".concat(this.textContent.trim(), "...")
        }).button(isLoading ? "loading" : "reset");
      });
    },
    selectFile: function selectFile(options, handler) {
      var _accept$multiple$opti = _objectSpread({
          accept: "",
          multiple: false
        }, options),
        accept = _accept$multiple$opti.accept,
        multiple = _accept$multiple$opti.multiple;
      return this.each(function () {
        var triggerEl = this;
        $(triggerEl).on("click", function (event) {
          event.preventDefault();
          $("<input type=\"file\" accept=\"".concat(accept, "\" multiple=\"").concat(multiple, "\" />")).on("change", function () {
            var files = $(this).prop("files");
            handler.bind(triggerEl)(files, options);
          }).click();
        });
      });
    },
    options: function options(_options, iteratee) {
      var mapper;
      if ($.isArray(iteratee)) {
        var _iteratee = _slicedToArray(iteratee, 2),
          valueKey = _iteratee[0],
          labelKey = _iteratee[1];
        mapper = function mapper(option) {
          return {
            value: option[valueKey],
            label: option[labelKey]
          };
        };
      } else if ($.isFunction(iteratee)) {
        mapper = iteratee;
      }
      return this.each(function () {
        $(this).html((_options.length > 0 && !this.multiple ? "<option></option>" : "") + _options.map(function (option) {
          var _ref = mapper ? mapper(option) : option,
            value = _ref.value,
            label = _ref.label;
          return "<option value=\"".concat(value, "\">").concat(label, "</option>");
        }).join(""));
      });
    },
    clearForm: function clearForm() {
      var shouldClearValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this.each(function () {
        var validator = $(this).data("bootstrapValidator");

        var excluded = validator.options.excluded;

        validator.options.excluded = [];
        validator.resetForm(false);

        validator.options.excluded = excluded;
        if (shouldClearValues) {
          this.reset();
        }
      });
    },
    enforceRoleAccess: function enforceRoleAccess(userRole) {
      return this.each(function () {
        var el = $(this);
        var allow = el.attr("data-role-access");
        if (allow && !allow.split(",").includes(userRole)) {
          el.remove();
        }
      });
    },
    loadingPage: function loadingPage(isLoading, callback) {
      if (isLoading) {
        $(".splash-screen").fadeIn("fast");
      } else {
        $(".splash-screen").fadeOut("slow").promise().done(function () {
          callback && callback();
        });
      }
    }
  });
})(jQuery);

},{}],6:[function(require,module,exports){
(function (global){(function (){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
var _dataImport = _interopRequireDefault(require("../../services/api/dataImport"));
var _organization = _interopRequireDefault(require("../../services/api/organization"));
var _unit = _interopRequireDefault(require("../../services/api/unit"));
var _auditLog = _interopRequireDefault(require("../../services/api/auditLog"));
var _generalConfiguration = _interopRequireDefault(require("../../services/api/generalConfiguration"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var getReportData = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var start, end, rangeWeek, promises, i, startDate, endDate, results, responses;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          start = moment().subtract(3, "months");
          end = moment();
          rangeWeek = end.diff(start, "weeks");
          promises = [];
          for (i = 0; i < rangeWeek; i++) {
            startDate = 1 == rangeWeek ? start.startOf("day").toISOString() : moment().subtract(i + 1, "weeks").startOf("day").toISOString();
            endDate = moment().subtract(i, "weeks").endOf("day").toISOString();
            promises.push(_auditLog["default"].list({
              startDate: startDate,
              endDate: endDate
            }));
          }
          results = [];
          _context.next = 8;
          return Promise.all(promises);
        case 8:
          responses = _context.sent;
          responses.forEach(function (response) {
            results = [].concat(_toConsumableArray(results), _toConsumableArray(response.data));
          });
          return _context.abrupt("return", results);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getReportData() {
    return _ref.apply(this, arguments);
  };
}();
function _default() {
  var userRole = _userProfile["default"].role;
  var header = this;
  this.find("#admin-menu").children().enforceRoleAccess(userRole).each(function () {
    var btn = $(this);
    if (window.location.pathname === btn.attr("href")) {
      btn.addClass("active");
    }
  });
  this.find(".btn-reset-organization").on("click", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Swal.fire({
            title: "WARNING: Confirm Reset CAD Data",
            text: "Are you SURE you wish to clear CAD Data?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
          });
        case 3:
          result = _context2.sent;
          if (result.value) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          _context2.next = 8;
          return _organization["default"].resetData(_userProfile["default"].organizationId);
        case 8:
          Swal.fire("Reset!", "Organization successfully reset", "success");
          _context2.next = 14;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          Swal.fire({
            type: "error",
            text: _context2.t0.message
          });
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  })));
  this.find(".btn-update-unit-list").selectFile({
    accept: ".csv"
  }, function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(files) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(files.length < 1)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            $(this).loading(true);
            _context3.prev = 3;
            _context3.next = 6;
            return _unit["default"].importUnitList(files[0]);
          case 6:
            Swal.fire("Update!", "Upload units list successfully", "success");
            _context3.next = 12;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            Swal.fire({
              type: "error",
              text: _context3.t0.message
            });
          case 12:
            _context3.prev = 12;
            $(this).loading(false);
            return _context3.finish(12);
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this, [[3, 9, 12, 15]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
  this.find(".btn-upload-contact-unit").selectFile({
    accept: ".csv"
  }, function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(files) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(files.length < 1)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            $(this).loading(true);
            _context4.prev = 3;
            _context4.next = 6;
            return _unit["default"].importContactUnit(files[0]);
          case 6:
            Swal.fire("Update!", "Upload contact units successfully", "success");
            _context4.next = 12;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](3);
            Swal.fire({
              type: "error",
              text: _context4.t0.message
            });
          case 12:
            _context4.prev = 12;
            $(this).loading(false);
            return _context4.finish(12);
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[3, 9, 12, 15]]);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }());
  this.find(".btn-update-quadrants").selectFile({
    accept: ".kml"
  }, function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5(files) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!(files.length < 1)) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.prev = 2;
            $(this).loading(true);
            $(this).loadingPage(true);
            _context5.next = 7;
            return _dataImport["default"].importQuadrant(files[0]);
          case 7:
            $(this).loading(false);
            $(this).loadingPage(false);
            _context5.next = 14;
            break;
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](2);
            if (_context5.t0.status === 500 && _context5.t0.message.includes("timed out")) {
              $(this).loading(false);
            } else {
              $(this).loading(false);
              $(this).loadingPage(false);
              Swal.fire({
                type: "error",
                text: _context5.t0.message
              });
            }
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this, [[2, 11]]);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }());
  this.find(".btn-update-beats").selectFile({
    accept: ".kml"
  }, function () {
    var _ref6 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee6(files) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(files.length < 1)) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            _context6.prev = 2;
            $(this).loading(true);
            $(this).loadingPage(true);
            _context6.next = 7;
            return _dataImport["default"].importBeat(files[0]);
          case 7:
            $(this).loading(false);
            $(this).loadingPage(false);
            _context6.next = 14;
            break;
          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](2);
            if (_context6.t0.status === 500 && _context6.t0.message.includes("timed out")) {
              $(this).loading(false);
            } else {
              $(this).loading(false);
              $(this).loadingPage(false);
              Swal.fire({
                type: "error",
                text: _context6.t0.message
              });
            }
          case 14:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this, [[2, 11]]);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }());
  if (userRole !== global.userRole.User) {
    var btnToggleSmtp = $(".btn-toggle-smtp");
    btnToggleSmtp.hide();
    _generalConfiguration["default"].getMailConfig().then(function (getMailConfigResponse) {
      var _global$organization;
      var isActive = userRole === global.userRole.Admin ? getMailConfigResponse.data.active : (_global$organization = global.organization) === null || _global$organization === void 0 ? void 0 : _global$organization.smtpStatus;
      btnToggleSmtp.show();
      btnToggleSmtp.text(isActive ? "Disable SMTP" : "Enable SMTP").on("click", _asyncToGenerator(_regeneratorRuntime().mark(function _callee7() {
        var willEnable, result;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              willEnable = btnToggleSmtp.text() === "Enable SMTP";
              if (willEnable) {
                _context7.next = 7;
                break;
              }
              _context7.next = 4;
              return Swal.fire({
                type: "warning",
                title: "WARNING: Disable SMTP!",
                text: "Emails won't be sent anymore. Are you sure?",
                showCancelButton: true,
                cancelButtonText: "No",
                confirmButtonText: "Yes"
              });
            case 4:
              result = _context7.sent;
              if (result.value) {
                _context7.next = 7;
                break;
              }
              return _context7.abrupt("return");
            case 7:
              _context7.prev = 7;
              btnToggleSmtp.loading(true);
              _context7.next = 11;
              return _generalConfiguration["default"].updateSMTP(willEnable);
            case 11:
              btnToggleSmtp.loading(false);
              _context7.next = 14;
              return Swal.fire({
                type: "success",
                title: "Successful!",
                text: "SMTP is ".concat(willEnable ? "active" : "inactive")
              });
            case 14:
              btnToggleSmtp.text(willEnable ? "Disable SMTP" : "Enable SMTP");
              _context7.next = 20;
              break;
            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7["catch"](7);
              Swal.fire({
                type: "error",
                title: "Update SMTP unsucessfully!",
                text: _context7.t0
              });
            case 20:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[7, 17]]);
      })));
    });
  }
  function createAuditLogReport(reportData) {
    var timezone = moment.tz.guess();
    var header = ["Date", "User", "Action", "Description"].join(",");
    var body = reportData.sort(function (a, b) {
      return new Date(b.logTime).getTime() - new Date(a.logTime).getTime();
    }).map(function (_ref8) {
      var logTime = _ref8.logTime,
        userName = _ref8.userName,
        actionName = _ref8.actionName,
        description = _ref8.description;
      return [moment(new Date(logTime)).tz(timezone).format("hh:mm A MM/DD/YYYY"), userName, actionName, description.replace(/\n/g, "")].join(",");
    }).join("\n");
    return "".concat(header, "\n").concat(body);
  }
  header.on("click", "#btn-audit-log", function () {
    var _ref9 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee8(event) {
      var btnExport, timezone, startDate, endDate, reportData, fileName;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            event.preventDefault();
            btnExport = $(this);
            timezone = moment.tz.guess();
            _context8.prev = 3;
            btnExport.loading(true);
            startDate = moment().subtract(3, "months").format("YYYY-MM-DD");
            endDate = moment().format("YYYY-MM-DD");
            _context8.next = 9;
            return getReportData();
          case 9:
            reportData = _context8.sent;
            fileName = "Audit Log Export" + " ".concat(moment.tz(startDate, timezone).format("DD-MMM YYYY"), " - ") + " ".concat(moment.tz(endDate, timezone).format("DD-MMM YYYY"), " - ") + "report of ".concat(reportData.length, " row").concat(reportData.length === 1 ? "" : "s") + ".csv";
            global.Utils.saveAsCsv(fileName, createAuditLogReport(reportData));
            _context8.next = 17;
            break;
          case 14:
            _context8.prev = 14;
            _context8.t0 = _context8["catch"](3);
            Swal.fire({
              type: "error",
              text: _context8.t0.message
            });
          case 17:
            _context8.prev = 17;
            btnExport.loading(false);
            return _context8.finish(17);
          case 20:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this, [[3, 14, 17, 20]]);
    }));
    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }());
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../models/userProfile":17,"../../services/api/auditLog":31,"../../services/api/dataImport":36,"../../services/api/generalConfiguration":38,"../../services/api/organization":42,"../../services/api/unit":46}],7:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleXMLTemplate = void 0;
var _constant = require("../../common/constant");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DescriptionType = {
  ASSIGNED: "Dispatched Call Number",
  DISPATCHED: "Dispatched Call Number",
  ENROUTE: "Enroute",
  ON_SCENE: "On Scene",
  ARRIVED: "PC",
  TRANSPORT: "Transport",
  AT_HOSPITAL: "At Hospital",
  DEPART_HOSPITAL: "Depart Hospital",
  AVAILABLE: "Unit Cleared From call"
};
var DEFAULT_UNIT_LOG_DATE = {
  assignedDate: "",
  dispatchedDate: "",
  enrouteDate: "",
  onSceneDate: "",
  arrivedDate: "",
  transportDate: "",
  atHospitalDate: "",
  departHospitalDate: "",
  availableDate: ""
};
var populateDateOfUnitLogs = function populateDateOfUnitLogs(unitLog, _ref) {
  var description = _ref.description,
    createdAt = _ref.createdAt;
  var fields = [{
    key: "assignedDate",
    type: DescriptionType.ASSIGNED
  }, {
    key: "dispatchedDate",
    type: DescriptionType.DISPATCHED
  }, {
    key: "enrouteDate",
    type: DescriptionType.ENROUTE
  }, {
    key: "onSceneDate",
    type: DescriptionType.ON_SCENE
  }, {
    key: "arrivedDate",
    type: DescriptionType.ARRIVED
  }, {
    key: "transportDate",
    type: DescriptionType.TRANSPORT
  }, {
    key: "atHospitalDate",
    type: DescriptionType.AT_HOSPITAL
  }, {
    key: "departHospitalDate",
    type: DescriptionType.DEPART_HOSPITAL
  }, {
    key: "availableDate",
    type: DescriptionType.AVAILABLE
  }];
  for (var _i = 0, _fields = fields; _i < _fields.length; _i++) {
    var ele = _fields[_i];
    if (description.indexOf(ele.type) !== -1) {
      unitLog[ele.key] = createdAt;
    }
  }
  return unitLog;
};
var populateUnitLogs = function populateUnitLogs(_ref2) {
  var unitLogs = _ref2.unitLogs,
    agencyType = _ref2.agencyType,
    queryCfsUnitLogReport = _ref2.queryCfsUnitLogReport;
  var filteredUnitLogs = _.filter(unitLogs, function (ele) {
    var _ele$Units;
    return ((_ele$Units = ele.Units) === null || _ele$Units === void 0 ? void 0 : _ele$Units.AgencyType) === agencyType;
  });
  var groupedUnitLogs = _.groupBy(filteredUnitLogs, "unitId");
  if (!_.isEmpty(queryCfsUnitLogReport)) {
    return queryCfsUnitLogReport.map(function (i) {
      var AssignedDateTime = i.AssignedDateTime,
        CFSID = i.CFSID,
        UnitID = i.UnitID,
        DispatchedDateTime = i.DispatchedDateTime,
        EnrouteDateTime = i.EnrouteDateTime,
        AtSceneDateTime = i.AtSceneDateTime,
        ArrivedDateTime = i.ArrivedDateTime,
        TransportDateTime = i.TransportDateTime,
        AtHospitalDateTime = i.AtHospitalDateTime,
        DepartHospitalDateTime = i.DepartHospitalDateTime,
        AvailableDateTime = i.AvailableDateTime;
      var unitLog = {
        assignedDate: AssignedDateTime,
        dispatchedDate: DispatchedDateTime,
        enrouteDate: EnrouteDateTime,
        onSceneDate: AtSceneDateTime,
        arrivedDate: ArrivedDateTime,
        transportDate: TransportDateTime,
        atHospitalDate: AtHospitalDateTime,
        departHospitalDate: DepartHospitalDateTime,
        availableDate: AvailableDateTime,
        unitId: UnitID
      };
      return unitLog;
    }).filter(function (i) {
      return i;
    });
  }
  return Object.keys(groupedUnitLogs).map(function (unitId) {
    var unitLog = _objectSpread(_objectSpread({}, DEFAULT_UNIT_LOG_DATE), {}, {
      unitId: unitId
    });
    var groupedData = groupedUnitLogs[unitId];
    var lastedAvailableIndex = _.findLastIndex(groupedData, function (ele) {
      return ele.description.indexOf(DescriptionType.AVAILABLE) !== -1;
    });
    var populatedUnitLogs = groupedData.length === lastedAvailableIndex + 1 ? groupedData : groupedData.slice(lastedAvailableIndex + 1);
    var _iterator = _createForOfIteratorHelper(populatedUnitLogs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
          description = _step$value.description,
          createdAt = _step$value.createdAt;
        unitLog = populateDateOfUnitLogs(unitLog, {
          description: description,
          createdAt: createdAt
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return unitLog;
  });
};
var getBaseTemplate = function getBaseTemplate(content) {
  return "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<CADLiteExport>".concat(content, "</CADLiteExport>");
};
var getCallTemplate = function getCallTemplate(element) {
  var _global$Utils$convert = global.Utils.convertPropertyObjectNullToEmpty(element),
    disposition = _global$Utils$convert.disposition,
    dispositionDate = _global$Utils$convert.dispositionDate,
    rpName = _global$Utils$convert.rpName,
    rpNumber = _global$Utils$convert.rpNumber,
    unitLogs = _global$Utils$convert.unitLogs,
    narrativeLogs = _global$Utils$convert.narrativeLogs,
    cfsId = _global$Utils$convert.cfsId,
    createdAt = _global$Utils$convert.createdAt,
    location = _global$Utils$convert.location,
    callType = _global$Utils$convert.callType,
    callPriority = _global$Utils$convert.callPriority,
    callStatus = _global$Utils$convert.callStatus,
    closedDateTime = _global$Utils$convert.closedDateTime,
    qualifier = _global$Utils$convert.qualifier,
    userName = _global$Utils$convert.userName;
  var narrativeReviews = narrativeLogs.reduce(function (total, element) {
    total += "\n                <NarrativeReview>\n                    <EnteredDate>".concat(Utils.convertFromUtcFormat(element.createdAt, TIME_ZONE_UTC, FORMAT_ISO_8601), "</EnteredDate>\n                    <EnteredBy>").concat(element.AspNetUsers.userName, "</EnteredBy>\n                    <NarrativeText>").concat(element.description, "</NarrativeText>\n                </NarrativeReview>\n             ");
    return total;
  }, "");
  var unitReviews = unitLogs.reduce(function (total, element) {
    total += "\n                <UnitActivityReview>\n                    <UnitNumber>".concat(element.unitId, "</UnitNumber>\n                    <AssignedDateTime>").concat(Utils.convertFromUtcFormat(element.assignedDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</AssignedDateTime>\n                    <DispatchedDateTime>").concat(Utils.convertFromUtcFormat(element.dispatchedDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</DispatchedDateTime>\n                    <EnrouteDateTime>").concat(Utils.convertFromUtcFormat(element.enrouteDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</EnrouteDateTime>\n                    <AtSceneDateTime>").concat(Utils.convertFromUtcFormat(element.onSceneDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</AtSceneDateTime>\n                    <ArrivedDateTime>").concat(Utils.convertFromUtcFormat(element.arrivedDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</ArrivedDateTime>\n                    <TransportDateTime>").concat(Utils.convertFromUtcFormat(element.transportDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</TransportDateTime>\n                    <AtHospitalDateTime>").concat(Utils.convertFromUtcFormat(element.atHospitalDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</AtHospitalDateTime>\n                    <DepartHospitalDateTime>").concat(Utils.convertFromUtcFormat(element.departHospitalDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</DepartHospitalDateTime>\n                    <AvailableDateTime>").concat(Utils.convertFromUtcFormat(element.availableDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</AvailableDateTime>\n                </UnitActivityReview>\n             ");
    return total;
  }, "");
  return "\n        <Call>\n            <CallReview>\n                <CallType>".concat(callType, "</CallType>\n                <Address>").concat(location, "</Address>\n                <Qualifier>").concat(qualifier, "</Qualifier>\n                <CreateDateTime>").concat(Utils.convertFromUtcFormat(createdAt, TIME_ZONE_UTC, FORMAT_ISO_8601), "</CreateDateTime>\n                <CreateUser>").concat(userName, "</CreateUser>\n                <CallPhone>").concat(rpNumber, "</CallPhone> \n                <CallStatus>").concat(callStatus, "</CallStatus>\n                <CallPriority>").concat(callPriority, "</CallPriority>  \n                <ClosedDateTime>").concat(Utils.convertFromUtcFormat(closedDateTime, TIME_ZONE_UTC, FORMAT_ISO_8601), "</ClosedDateTime>\n                <CallNumber>").concat(cfsId, "</CallNumber> \n            </CallReview>\n            <NarrativeReviews>").concat(narrativeReviews, "</NarrativeReviews>\n            <CallDisposition>\n                <Disposition>").concat(disposition, "</Disposition>\n                <CreateDateTime>").concat(Utils.convertFromUtcFormat(dispositionDate, TIME_ZONE_UTC, FORMAT_ISO_8601), "</CreateDateTime>\n            </CallDisposition>\n            <UnitActivityReviews>").concat(unitReviews, "</UnitActivityReviews>\n            <PersonReview>\n                <ContactPhone>").concat(rpNumber, "</ContactPhone> \n                <FullName>").concat(rpName, "</FullName> \n                <CreateDateTime>").concat(Utils.convertFromUtcFormat(createdAt, TIME_ZONE_UTC, FORMAT_ISO_8601), "</CreateDateTime> \n            </PersonReview>\n        </Call>");
};
var populateTemplate = function populateTemplate(templates) {
  var content = templates.reduce(function (total, element) {
    total += "".concat(element, "\n");
    return total;
  }, "");
  return getBaseTemplate(content);
};
var handleXMLTemplate = exports.handleXMLTemplate = function handleXMLTemplate(reports) {
  var populatedData = reports.reduce(function (total, element) {
    var disposition = element.disposition,
      dispositionDate = element.dispositionDate,
      rpName = element.rpName,
      rpNumber = element.rpNumber,
      unitLogs = element.unitLogs,
      narrativeLogs = element.narrativeLogs,
      cfsId = element.cfsId,
      clearDate = element.clearDate,
      createdBy = element.createdBy,
      createdAt = element.createdAt,
      location = element.location,
      isClosed = element.isClosed,
      policeCallTypeStatus = element.policeCallTypeStatus,
      fireCallTypeStatus = element.fireCallTypeStatus,
      policeCallType = element.policeCallType,
      fireCallType = element.fireCallType,
      qualifier = element.qualifier,
      queryCfsUnitLogReport = element.queryCfsUnitLogReport;
    var mappingTypes = [{
      agencyType: _constant.AgencyType.Police,
      callType: policeCallType,
      callPriority: policeCallTypeStatus,
      callStatus: policeCallTypeStatus === _constant.PoliceCallTypeStatus.Advised ? _constant.PoliceCallTypeStatus.Five : policeCallTypeStatus
    }, {
      agencyType: _constant.AgencyType.Fire,
      callType: fireCallType,
      callPriority: fireCallTypeStatus,
      callStatus: fireCallTypeStatus && fireCallTypeStatus.replace(/\D/g, "")
    }];
    var filteredTypes = mappingTypes.filter(function (element) {
      return element.callType;
    });
    filteredTypes.forEach(function (_ref3) {
      var callType = _ref3.callType,
        callPriority = _ref3.callPriority,
        callStatus = _ref3.callStatus,
        agencyType = _ref3.agencyType;
      var element = {
        disposition: disposition,
        dispositionDate: dispositionDate,
        rpName: rpName,
        rpNumber: rpNumber,
        narrativeLogs: narrativeLogs,
        cfsId: cfsId,
        createdBy: createdBy,
        createdAt: createdAt,
        location: location,
        callType: callType,
        callPriority: callPriority,
        callStatus: callStatus,
        qualifier: qualifier,
        userName: createdBy.userName,
        closedDateTime: isClosed ? clearDate : "",
        unitLogs: populateUnitLogs({
          unitLogs: unitLogs,
          agencyType: agencyType,
          queryCfsUnitLogReport: queryCfsUnitLogReport
        })
      };
      var template = getCallTemplate(element);
      total.push(template);
    });
    return total;
  }, []);
  return populateTemplate(populatedData);
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../common/constant":4}],8:[function(require,module,exports){
(function (global){(function (){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
var _cfs = _interopRequireDefault(require("../../services/api/cfs"));
var helper = _interopRequireWildcard(require("./helper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function renderCfs() {
  var cfsId = this.cfsId,
    location = this.location,
    qualifier = this.qualifier,
    assignedBeat = this.assignedBeat,
    assignedGrid = this.assignedGrid,
    emd = this.emd,
    rpName = this.rpName,
    rpNumber = this.rpNumber,
    createdBy = this.createdBy,
    createdAt = this.createdAt,
    clearDate = this.clearDate;
  return "\n      <thead class=\"thead-light\">\n        <th colspan=\"6\">CFS Detail Report: CFS ".concat(cfsId || "", "</th>\n      </thead>\n      <tbody>\n        <tr>\n          <th>Address</th>\n          <td colspan=\"3\">").concat(location, "</td>\n          <th>Qualifier</th>\n          <td>").concat(qualifier, "</td>\n        </tr>\n        <tr>\n          <th>Beat</th>\n          <td>").concat(assignedBeat, "</td>\n          <th>Quadrant</th>\n          <td>").concat(assignedGrid, "</td>\n          <th>EMD</th>\n          <td>").concat(emd, "</td>\n        </tr>\n        <tr>\n          <th>RP Name</th>\n          <td>").concat(rpName, "</td>\n          <th>RP Number</th>\n          <td>").concat(rpNumber, "</td>\n          <th>Call Taker</th>\n          <td>").concat(createdBy.userName, "</td>\n        </tr>\n        <tr>\n          <th>Create Date</th>\n          <td class=\"tz-date\">").concat(createdAt, "</td>\n          <th>Clear Date</th>\n          <td class=\"tz-date\">").concat(clearDate, "</td>\n          <th/>\n          <td/>\n        </tr>\n      </tbody>\n    ");
}
function renderAgency() {
  var policeCallType = this.policeCallType,
    policeCallTypeStatus = this.policeCallTypeStatus,
    fireCallType = this.fireCallType,
    fireCallTypeStatus = this.fireCallTypeStatus;
  var tableView = [{
    callType: policeCallType,
    priority: policeCallTypeStatus
  }, {
    callType: fireCallType,
    priority: fireCallTypeStatus
  }].filter(function (_ref) {
    var callType = _ref.callType;
    return !!callType;
  }).map(function (_ref2) {
    var callType = _ref2.callType,
      priority = _ref2.priority;
    return "\n      <tr>\n        <td>".concat(callType, "</td>\n        <td>").concat(priority, "</td>\n        <td/>\n        <td/>\n        <td/>\n        <td/>\n      </tr>");
  }).join("");
  return "\n    <thead class=\"thead-light\">\n      <th colspan=\"6\">Agencies</th>\n    </thead>\n    <tbody>\n      <tr>\n        <th colspan=\"1\">Call Type</th>\n        <th colspan=\"1\">Priority</th>\n        <td/>\n        <td/>\n        <td/>\n        <td/>\n      </tr>\n      ".concat(tableView, "\n    </tbody>\n  ");
}
function renderNarrativeLogs() {
  var narrativeLogs = this.narrativeLogs || [];
  var tableView = _.reverse(narrativeLogs).map(function (_ref3) {
    var createdAt = _ref3.createdAt,
      actionType = _ref3.actionType,
      description = _ref3.description,
      AspNetUsers = _ref3.AspNetUsers;
    return "\n      <tr>\n        <td class=\"tz-date\">".concat(createdAt, "</td>\n        <td>").concat(actionType, "</td>\n        <td colspan=\"3\">").concat(description, "</td>\n        <td>").concat(AspNetUsers.userName, "</td>\n      </tr>");
  }).join("");
  return "\n    <thead class=\"thead-light\">\n      <th colspan=\"6\">Call Narrative</th>\n    </thead>\n    <tbody>\n      <tr>\n        <td>Date</td>\n        <td>Action</td>\n        <td colspan=\"3\">Description</td>\n        <td>User</td>\n      </tr>\n      ".concat(tableView, "\n    </tbody>");
}
function renderCallDisposition() {
  var disposition = this.disposition,
    dispositionDate = this.dispositionDate;
  return "\n    <thead class=\"thead-light\">\n      <th colspan=\"6\">Call Disposition</th>\n    </thead>\n    <tbody>\n      <tr>\n        <td>Date</td>\n        <td>Disposition</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td class=\"tz-date\">".concat(dispositionDate, "</td>\n        <td>").concat(disposition, "</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n      </tr>\n    </tbody>\n  ");
}
function renderUnitLogs() {
  var unitLogs = this.unitLogs || [];
  var tableView = _.reverse(unitLogs).map(function (_ref4) {
    var createdAt = _ref4.createdAt,
      actionType = _ref4.actionType,
      unitID = _ref4.unitId,
      description = _ref4.description,
      AspNetUsers = _ref4.AspNetUsers;
    return "\n        <tr>\n          <td class=\"tz-date\">".concat(createdAt, "</td>\n          <td>").concat(actionType, "</td>\n          <td>").concat(unitID, "</td>\n          <td colspan=\"2\">").concat(description, "</td>\n          <td>").concat(AspNetUsers.userName, "</td>\n        </tr>");
  }).join("");
  return "\n    <thead class=\"thead-light\">\n      <th colspan=\"6\">Unit Log</th>\n    </thead>\n    <tbody>\n      <tr>\n        <td>Date</td>\n        <td>Action</td>\n        <td>Unit</td>\n        <td colspan=\"2\">Description</td>\n        <td>User</td>\n      </tr>\n      ".concat(tableView, "\n    </tbody>");
}
function renderCallLogs() {
  var callLogs = this.callLogs || [];
  var tableView = _.reverse(callLogs).map(function (_ref5) {
    var createdAt = _ref5.createdAt,
      actionType = _ref5.actionType,
      unitID = _ref5.unitId,
      description = _ref5.description,
      AspNetUsers = _ref5.AspNetUsers;
    return "\n        <tr>\n          <td class=\"tz-date\">".concat(createdAt, "</td>\n          <td>").concat(actionType, "</td>\n          <td>").concat(unitID, "</td>\n          <td colspan=\"2\">").concat(description, "</td>\n          <td>").concat(AspNetUsers.userName, "</td>\n        </tr>\n      ");
  }).join("");
  return "\n    <thead class=\"thead-light\">\n      <th colspan=\"6\">Call Log</th>\n    </thead>\n    <tbody>\n      <tr>\n        <td>Date</td>\n        <td>Action</td>\n        <td>Unit</td>\n        <td colspan=\"2\">Description</td>\n        <td>User</td>\n      </tr>\n      ".concat(tableView, "\n    </tbody>\n  ");
}
function renderReportPage() {
  var _this = this;
  var cfsId = this.cfsId,
    incidentId = this.incidentId,
    isAssociated = this.isAssociated;
  var content = [renderCfs, renderAgency, renderNarrativeLogs, renderCallDisposition, renderUnitLogs, renderCallLogs].map(function (renderer) {
    return renderer.call(_this);
  }).join("");
  return "\n    <div style='page-break-after:always'>\n      <h3 class=\"text-center mb-3\">CFS Detail Report: CFS ".concat(cfsId || "", ", Incident#: ").concat(incidentId || "", "</h3>\n      ").concat(isAssociated ? "<h4 class='text-center mb-3'>CALL WAS ASSOCIATED</h4>" : "", "\n      <table class=\"table table-bordered table-sm\">\n          <thead class=\"invisible\">\n          <th colspan=\"6\">&nbsp;</th>\n          </thead>\n          ").concat(content, "\n      </table>\n    </div>\n  ");
}
function formatReport(reportHtml) {
  var userTimeZone = _userProfile["default"].timezone;
  var $report = $(reportHtml);
  $report.find("tbody").each(function () {
    var $tbody = $(this);
    $tbody.find("tr:last").clone(false).each(function () {
      $(this).children().empty();
    }).appendTo($tbody);
    $tbody.find("td").each(function () {
      var $td = $(this);
      if (["null", "undefined", ""].includes($td.text())) {
        $(this).html("&nbsp;");
      } else if ($td.hasClass("tz-date")) {
        var timeCheck = Utils.convertFromUtcFormat($td.text(), global.userProfile.timezone, FORMAT_TIME_UI);
        $td.text(timeCheck);
      }
    });
  });
  return $report;
}
function renderReport(reports) {
  return formatReport(reports.map(function (report) {
    return renderReportPage.call(report);
  }).join(""));
}
function printReport(dataView, target) {
  var el = target ? target.find("#printarea") : $("#printarea");
  el.html(dataView);
  window.print();
  el.html("");
}
function batchPrintModal() {
  var modalDialog = $(this);
  var userTimeZone = _userProfile["default"].timezone;
  var currentDate = new Date();
  var dtPickerDefaults = {
    format: "MM/DD/YYYY h:mm a",
    defaultDate: moment.tz(currentDate, userTimeZone).format("MM/DD/YYYY"),
    defaultTime: moment.tz(currentDate, userTimeZone).format("HH:mm")
  };
  modalDialog.find("#cfsPrintStartDt, #cfsPrintEndDt").datetimepicker(dtPickerDefaults);
  modalDialog.find(".input-group.date").on("click", ".input-group-addon", function () {
    $(this).prev().datetimepicker("show");
  });
  var handleReports = function () {
    var _ref6 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(self, callback) {
      var button, closeModalBtn, valueStartDate, valueEndDate, startDate, endDate, cfsNumbers, includedCancelCalls, policeMigratedYes, policeMigratedNo, policeNA, fireMigratedYes, fireMigratedNo, fireNA, _yield$cfsApi$getRepo, reports;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            button = $(self);
            closeModalBtn = modalDialog.find('button[data-dismiss="modal"]');
            _context.prev = 2;
            button.attr("disabled", true);
            closeModalBtn.attr("disabled", true);
            $(".cfs-view").removeClass("print-cfs");
            valueStartDate = modalDialog.find("#cfsPrintStartDt").val();
            valueEndDate = modalDialog.find("#cfsPrintEndDt").val();
            startDate = valueStartDate ? new Date(valueStartDate) : null;
            endDate = valueEndDate ? new Date(valueEndDate) : null;
            cfsNumbers = $("#cfsFilterNumbers").val().length > 0 ? $("#cfsFilterNumbers").val() : null;
            includedCancelCalls = $("#ckIncludeCancel").prop("checked");
            policeMigratedYes = $("#ckPoliceYes").prop("checked");
            policeMigratedNo = $("#ckPoliceNo").prop("checked");
            policeNA = $("#ckPoliceNA").prop("checked");
            fireMigratedYes = $("#ckFireYes").prop("checked");
            fireMigratedNo = $("#ckFireNo").prop("checked");
            fireNA = $("#ckFireNA").prop("checked");
            _context.next = 20;
            return _cfs["default"].getReport({
              startDate: startDate,
              endDate: endDate,
              includedCancelCalls: includedCancelCalls,
              policeMigratedYes: policeMigratedYes,
              policeMigratedNo: policeMigratedNo,
              policeNA: policeNA,
              fireMigratedYes: fireMigratedYes,
              fireMigratedNo: fireMigratedNo,
              fireNA: fireNA,
              cfsNumbers: cfsNumbers,
              status: null
            });
          case 20:
            _yield$cfsApi$getRepo = _context.sent;
            reports = _yield$cfsApi$getRepo.data;
            _context.next = 24;
            return callback(reports);
          case 24:
            _context.next = 29;
            break;
          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](2);
            Swal.fire({
              type: "error",
              text: _context.t0.message
            });
          case 29:
            _context.prev = 29;
            button.attr("disabled", false);
            closeModalBtn.attr("disabled", false);
            return _context.finish(29);
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 26, 29, 33]]);
    }));
    return function handleReports(_x, _x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  modalDialog.on("click", ".btn-print", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          handleReports(this, function (reports) {
            var view = renderReport(reports);
            var parentEl = $("#admin-layout");
            printReport(view, parentEl);
          });
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this);
  })));
  modalDialog.on("click", ".btn-save-xml", _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          handleReports(this, function (reports) {
            var xmlTemplate = helper.handleXMLTemplate(reports);
            var blob = new Blob([xmlTemplate], {
              type: "text/xml"
            });
            global.Utils.saveAsCsv("cfs.xml", blob);
          });
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3, this);
  })));
}
var _default = exports["default"] = {
  batchPrintModal: batchPrintModal,
  renderReport: renderReport,
  printReport: printReport
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../models/userProfile":17,"../../services/api/cfs":32,"./helper":7}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _batchPrintModal = _interopRequireDefault(require("../batchPrintModal"));
var _totalCfsModal = _interopRequireDefault(require("../totalCfsModal"));
var _baseHeader = _interopRequireDefault(require("./baseHeader"));
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _baseHeader["default"])(function () {
  var $header = this;
  $header.on("click", "#open-cfs-print", function (event) {
    event.preventDefault();
    var modal = $header.find("#batchPrintModal");
    if (!modal.children().length) {
      modal.load("/Administrator/components/batchPrintModal.html", _batchPrintModal["default"].batchPrintModal);
    }
    modal.modal("show");
  });
  $header.on("click", "#open-cfs-export", function (event) {
    event.preventDefault();
    var modal = $header.find("#totalCfsModal");
    if (!modal.children().length) {
      modal.load("/Administrator/components/totalCfsModal.html", _totalCfsModal["default"]);
    }
    modal.modal("show");
  });
});

},{"../../models/userProfile":17,"../batchPrintModal":8,"../totalCfsModal":16,"./baseHeader":10}],10:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = baseHeader;
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _messageComposer = _interopRequireDefault(require("../messageComposer"));
var _constant = require("../../common/constant");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var userRole = _.get(_userProfile["default"], "role", "");
function baseHeader(binder) {
  return function () {
    var userName = _userProfile["default"].name;
    var userRole = _userProfile["default"].role;
    var userOrg = _userProfile["default"].organizationName;
    var $header = this;
    var $navBar = this.find("#navbar");
    document.title = userOrg ? "".concat(userOrg, " - Welcome") : "Admin";
    this.find(".user-name").html(userName);
    this.find(".navbar-brand").text(userOrg ? "".concat(userOrg, " CAD Lite") : "Admin");
    this.find("[data-role-access]").enforceRoleAccess(userRole);
    this.on("click", "#logout-btn", function () {
      var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              _auth["default"].signOut();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    $header.on("click", "#new-message-btn", function (event) {
      event.preventDefault();
      if ($navBar.find("#message-composer").length) {
        return;
      }
      $.get("/Administrator/components/messageComposer.html", function (data) {
        var firstData = data;
        var admin = _userProfile["default"].role === window.userRole.Admin ? "admin" : "";
        firstData = firstData.replace(/{{admin}}/g, admin);
        var $view = $navBar.append(firstData).find("#message-composer");
        _messageComposer["default"].call($view);
      });
    });
    binder.call(this);
  };
}

},{"../../common/constant":4,"../../models/userProfile":17,"../../services/auth":48,"../messageComposer":15}],11:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _resources = _interopRequireDefault(require("../../services/api/resources"));
var _baseHeader = _interopRequireDefault(require("./baseHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _baseHeader["default"])(function () {
  var _global$organization;
  var $resourceDropdown = this.find("#resources-dropdown");
  $resourceDropdown.on("hidden.bs.dropdown", function () {
    $(this).find(".show").removeClass("show");
  }).find(".dropdown-menu a.dropdown-toggle").on("click", function () {
    var $dropdownToggle = $(this);
    if (!$dropdownToggle.next().hasClass("show")) {
      $dropdownToggle.parents(".dropdown-menu").first().find(".show").removeClass("show");
    }
    $dropdownToggle.next(".dropdown-menu").toggleClass("show");
    $dropdownToggle.parents("li.nav-item.dropdown.show").on("hidden.bs.dropdown", function () {
      $(".dropdown-submenu .show").removeClass("show");
    });
    return false;
  });
  _resources["default"].list({
    isDisplay: true
  }).then(function (_ref) {
    var data = _ref.data;
    var _$groupBy = _.groupBy(data, function (i) {
        return i.type;
      }),
      _$groupBy$link = _$groupBy.link,
      link = _$groupBy$link === void 0 ? [] : _$groupBy$link,
      _$groupBy$file = _$groupBy.file,
      file = _$groupBy$file === void 0 ? [] : _$groupBy$file;
    $resourceDropdown.find(".dropdown-submenu ul").each(function (index, element) {
      var items = _.sortBy(index === 0 ? link : file, function (item) {
        return item.position;
      }).map(function (_ref2) {
        var name = _ref2.name,
          link = _ref2.link;
        return "<li><a href=\"".concat(link, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(name, "</a></li>");
      }).join("");
      $(element).html(items || "<li><a>(empty)</a></li>");
    });
  });
  var smtpStatus = (_global$organization = global.organization) === null || _global$organization === void 0 ? void 0 : _global$organization.smtpStatus;
  var smtpStatusTextEl = $('#smtp-status');
  smtpStatusTextEl.html(smtpStatus ? '<strong class="green">Enabled</strong>' : '<strong class="red">Disabled</strong>');
});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../services/api/resources":45,"./baseHeader":10}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _adminHeader = _interopRequireDefault(require("../../header/adminHeader"));
var _adminSubmenu = _interopRequireDefault(require("../../adminSubmenu"));
var _userProfile = _interopRequireDefault(require("../../../models/userProfile"));
var _constant = require("../../../common/constant");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _default(contentLayout, onComplete) {
  function connectSolace() {
    var isSuperAdmin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var factoryProps = new solace.SolclientFactoryProperties();
    factoryProps.profile = solace.SolclientFactoryProfiles.version10;
    solace.SolclientFactory.init(factoryProps);
    solace.SolclientFactory.setLogLevel(solace.LogLevel.WARN);
    solace.SessionProperties.connectTimeoutInMsecs = -1;
    if (isSuperAdmin) {
      subscriber = new TopicSubscriber([TOP_PIC[4]]);
    } else {
      subscriber = new TopicSubscriber(TOP_PIC[5]);
    }
    subscriber.connect();
  }
  return ["/Administrator/layouts/administratorLayout.html", function () {
    var isSubAdmin = _userProfile["default"].role === _constant.UserRole.SUPER_ADMIN;
    [_constant.UserRole.ORG_ADMIN, _constant.UserRole.SUPER_ADMIN].includes(_userProfile["default"].role) && connectSolace(isSubAdmin);
    var $adminLayout = $(this).children().first();
    $.get("/Administrator/components/header.html", function (html) {
      var $header = $adminLayout.find("#header").html(html);
      _adminHeader["default"].call($header);
    });
    $.get("/Administrator/components/adminSubmenu.html", function (html) {
      var $adminFunction = $adminLayout.find("#admin-function").html(html);
      _adminSubmenu["default"].call($adminFunction);
    });
    $.get(contentLayout, function (html) {
      var $content = $adminLayout.find("#content").append(html);
      $content.promise().done(function () {
        $(".splash-screen").fadeOut("slow");
      });
      onComplete.call($content);
    });
  }];
}

},{"../../../common/constant":4,"../../../models/userProfile":17,"../../adminSubmenu":6,"../../header/adminHeader":9}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _userHeader = _interopRequireDefault(require("../../header/userHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _default(contentLayout, onComplete) {
  return ["/MasterView/layouts/emptyLayout.html", function () {
    var $userLayout = $(this).children().first();
    $.get("/MasterView/components/header.html", function (html) {
      var $header = $userLayout.find("#header").html(html);
      _userHeader["default"].call($header);
    });
    $.get(contentLayout, function (html) {
      var $content = $userLayout.find("#content").append(html);
      onComplete.call($content);
    });
  }];
}

},{"../../header/userHeader":11}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _userHeader = _interopRequireDefault(require("../../header/userHeader"));
var _checkPin = _interopRequireDefault(require("../../../pages/checkPin"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _default(contentLayout, onComplete) {
  return ["/MasterView/layouts/masterLayout.html", function () {
    var $userLayout = $(this).children().first();
    $.get("/MasterView/components/header.html", function (html) {
      var $header = $userLayout.find("#header").html(html);
      _userHeader["default"].call($header);
    });
    $.get(contentLayout, function (html) {
      var $content = $userLayout.find("#content").append(html);
      onComplete.call($content);
    });
    $.get("/MasterView/components/checkPinModal.html", function (html) {
      $userLayout.find("#modal-section").append(html);
      (0, _checkPin["default"])(true);
    });
  }];
}

},{"../../../pages/checkPin":26,"../../header/userHeader":11}],15:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _constant = require("../../common/constant");
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
var _dataset = _interopRequireDefault(require("../../services/api/dataset"));
var _message = _interopRequireDefault(require("../../services/api/message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var MESSAGE_MAX_LENGTH = 280;
function _default() {
  var $messageComposer = this;
  var recipientType = {
    input: $messageComposer.find("#select-recipient-type")
  };
  var recipient = {
    input: $messageComposer.find("#select-recipient"),
    error: $messageComposer.find("#recipient-error")
  };
  var message = {
    input: $messageComposer.find("#message-content"),
    error: $messageComposer.find("#message-error")
  };
  var recipientTypeOptions = [{
    label: "Organisations",
    value: "Organisations"
  }, {
    label: "Groups",
    value: "Groups"
  }, {
    label: "Individuals",
    value: "Individuals"
  }];
  recipientType.input.options(recipientTypeOptions).select2({
    minimumResultsForSearch: -1
  });
  if (_userProfile["default"].role !== _constant.UserRole.SUPER_ADMIN) {
    $messageComposer.find("#receiver-info-section").remove();
  } else {
    _dataset["default"].listOrganizations().then(function (response) {
      var data = response.data;
      data.unshift({
        organizationName: "All Organizations",
        organizationId: null
      });
      recipient.input.options(data, function (_ref) {
        var organizationName = _ref.organizationName,
          organizationId = _ref.organizationId;
        return {
          label: organizationName,
          value: organizationId
        };
      }).select2({
        placeholder: "Select Organization"
      });
    });
  }
  var charsCountView = $messageComposer.find("#chars-count");
  var sendBtn = $messageComposer.find("#message-composer-send-btn");
  charsCountView.text("".concat(message.input.val().length, "/").concat(MESSAGE_MAX_LENGTH));
  message.error.attr("maxlength", MESSAGE_MAX_LENGTH);
  message.input.keyup(function (event) {
    charsCountView.text("".concat(event.target.value.length, "/").concat(MESSAGE_MAX_LENGTH));
  });
  sendBtn.click(_asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var requestData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(_userProfile["default"].role === _constant.UserRole.SUPER_ADMIN && !recipient.input.val())) {
            _context.next = 4;
            break;
          }
          recipient.error.text("Please choose at least 1 recipient");
          recipient.input.focus();
          return _context.abrupt("return");
        case 4:
          if (!(message.input.val().length < 1)) {
            _context.next = 8;
            break;
          }
          message.error.text("Please enter at least 1 character");
          message.input.focus();
          return _context.abrupt("return");
        case 8:
          requestData = {
            content: message.input.val(),
            organizationId: _userProfile["default"].organizationId || recipient.input.val()
          };
          _context.prev = 9;
          _context.next = 12;
          return _message["default"].create(requestData);
        case 12:
          _context.next = 14;
          return Swal.fire({
            text: "Message sent successfully",
            type: "success"
          });
        case 14:
          $messageComposer.remove();
          _context.next = 20;
          break;
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](9);
          Swal.fire({
            text: "Message sent unsuccessfully",
            type: "error"
          });
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9, 17]]);
  })));
  $messageComposer.on("click", "#message-composer-close-btn, #message-composer-cancel-btn", function (event) {
    event.preventDefault();
    $messageComposer.remove();
  });
  $messageComposer.find(".flexible-wrapper").resizable();
  var containmentX2 = $("#content").outerWidth(true) * 2;
  var containmentY2 = $("#content").outerHeight(true) * 2;
  $(".flexible-block").draggable({
    containment: [20, 70, containmentX2, containmentY2],
    cancel: ".panel-collapse",
    drag: function drag() {
      recipientType.input.options(recipientTypeOptions).select2("close");
    }
  });
  window.zindex++;
  $messageComposer.css("z-index", window.zindex);
  var configOptions = {
    color: null,
    show: null,
    text: null,
    type: "CLI",
    collapse: false,
    tabs: [],
    posX: ($(window).width() - 650) / 2,
    posY: 140,
    height: "133",
    width: "650",
    old: false
  };
  $messageComposer.css(Utils.setPositionWindow(configOptions));
}

},{"../../common/constant":4,"../../models/userProfile":17,"../../services/api/dataset":37,"../../services/api/message":41}],16:[function(require,module,exports){
(function (global){(function (){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
var _dataset = _interopRequireDefault(require("../../services/api/dataset"));
var _report = _interopRequireDefault(require("../../services/api/report"));
var _constant = require("../../common/constant");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function createReport(reportData) {
  var userTimeZone = _userProfile["default"].timezone;
  var header = ["Create Date/Time", "CFS #", "Incident #", "Address", "P- Call Type", "F- Call Type", "Create User", "Canceled", "Police Migrated", "Fire Migrated", "AssociatedFrom"].join(",");
  var body = reportData.map(function (_ref) {
    var createdAt = _ref.createdAt,
      cfsId = _ref.cfsId,
      incidentId = _ref.incidentId,
      location = _ref.location,
      policeCallType = _ref.policeCallType,
      fireCallType = _ref.fireCallType,
      createdUser = _ref.createdUser,
      isClosed = _ref.isClosed,
      IsPoliceMigrated = _ref.IsPoliceMigrated,
      IsFireMigrated = _ref.IsFireMigrated,
      disposition = _ref.disposition;
    return [Utils.convertFromUtcFormat(createdAt, global.userProfile.timezone, FORMAT_TIME_UI), cfsId, incidentId, location ? "\"".concat(location, "\"") : "", policeCallType, fireCallType, createdUser, isClosed && disposition === DISPOSITION_CFS.CAN, policeCallType ? IsPoliceMigrated ? "YES" : "NO" : "N/A", fireCallType ? IsFireMigrated ? "YES" : "NO" : "N/A"].join(",");
  }).join("\n");
  return "".concat(header, "\n").concat(body);
}
function _default() {
  var modalDialog = $(this);
  var userTimeZone = _userProfile["default"].timezone;
  var currentDate = new Date();
  var dtPickerDefaults = {
    format: "MM/DD/YYYY h:mm a",
    defaultDate: Utils.convertFromUtcFormat(currentDate, global.userProfile.timezone, "MM/DD/YYYY"),
    defaultTime: Utils.convertFromUtcFormat(currentDate, global.userProfile.timezone, "HH:mm")
  };
  modalDialog.find("#cfsExportStartDt, #cfsExportEndDt").datetimepicker(dtPickerDefaults);
  modalDialog.find(".input-group.date").on("click", ".input-group-addon", function () {
    $(this).prev().datetimepicker("show");
  });
  if (_userProfile["default"].role !== _constant.UserRole.SUPER_ADMIN) {
    modalDialog.find("select[name=ecc]").parents(".form-group").hide();
  } else {
    _dataset["default"].listOrganizations().then(function (_ref2) {
      var data = _ref2.data;
      modalDialog.find("select[name=ecc]").options(data, ["organizationId", "organizationName"]).val(data[0].organizationId).select2();
    });
  }
  modalDialog.on("click", ".btn-export", _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var btnExport, closeModalBtn, startDate, endDate, eccId, _yield$reportApi$list, reportData, fileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          btnExport = $(this);
          closeModalBtn = modalDialog.find('button[data-dismiss="modal"]');
          _context.prev = 2;
          $(btnExport).attr("disabled", true);
          closeModalBtn.attr("disabled", true);
          startDate = modalDialog.find("#cfsExportStartDt").val();
          endDate = modalDialog.find("#cfsExportEndDt").val();
          eccId = modalDialog.find("select[name=ecc]").val() || _userProfile["default"].organizationId;
          if (eccId) {
            _context.next = 10;
            break;
          }
          throw Error("Please select an ECC");
        case 10:
          if ($.isDate(new Date(startDate))) {
            _context.next = 12;
            break;
          }
          throw Error("Please enter Start Date");
        case 12:
          if ($.isDate(new Date(endDate))) {
            _context.next = 14;
            break;
          }
          throw Error("Please enter End Date");
        case 14:
          _context.next = 16;
          return _report["default"].list({
            startDate: Utils.convertToUtcFromTimeZone(startDate, global.userProfile.timezone),
            endDate: Utils.convertToUtcFromTimeZone(endDate, global.userProfile.timezone),
            organizationId: eccId
          });
        case 16:
          _yield$reportApi$list = _context.sent;
          reportData = _yield$reportApi$list.data;
          fileName = "Total CFS Export" + " ".concat(moment(startDate, "MM/DD/YYYY hh:mm a").format("DD-MMM YYYY"), " - ") + " ".concat(moment(endDate, "MM/DD/YYYY hh:mm a").format("DD-MMM YYYY"), " - ") + "report of ".concat(reportData.length, " row").concat(reportData.length === 1 ? "" : "s") + ".csv";
          global.Utils.saveAsCsv(fileName, createReport(reportData));
          _context.next = 25;
          break;
        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](2);
          Swal.fire({
            type: "error",
            text: _context.t0.message
          });
        case 25:
          _context.prev = 25;
          btnExport.attr("disabled", false);
          closeModalBtn.attr("disabled", false);
          return _context.finish(25);
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, this, [[2, 22, 25, 29]]);
  })));
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../common/constant":4,"../../models/userProfile":17,"../../services/api/dataset":37,"../../services/api/report":44}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constant = require("../common/constant");
var _user = _interopRequireDefault(require("../services/api/user"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var profile = {};
function refresh() {
  return _refresh.apply(this, arguments);
}
function _refresh() {
  _refresh = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var _yield$userApi$getPro, data, userName, roleName, timezone, organizationId, organizationName, pinCountFailed, latestSetPinFailedAt;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _user["default"].getProfile();
        case 2:
          _yield$userApi$getPro = _context.sent;
          data = _yield$userApi$getPro.data;
          userName = _.get(data, "userName", "");
          roleName = _.get(data, "userRoles.roleName", _constant.UserRole.ORG_USER);
          timezone = _.get(data, "timezone", "");
          organizationId = _.get(data, "additionalInfo.organizations.organizationId", "");
          organizationName = _.get(data, "additionalInfo.organizations.organizationName", "");
          pinCountFailed = _.get(data, "pinCountFailed", "");
          latestSetPinFailedAt = _.get(data, "latestSetPinFailedAt", "");
          profile = {
            userName: userName,
            roleName: roleName,
            timezone: timezone,
            organizationId: organizationId,
            organizationName: organizationName,
            pinCountFailed: pinCountFailed,
            latestSetPinFailedAt: latestSetPinFailedAt
          };
          return _context.abrupt("return", profile);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _refresh.apply(this, arguments);
}
var _default = exports["default"] = {
  refresh: refresh,
  get name() {
    return profile.userName;
  },
  get role() {
    return profile.roleName;
  },
  get timezone() {
    return profile.timezone;
  },
  get organizationId() {
    return profile.organizationId;
  },
  get organizationName() {
    return profile.organizationName;
  },
  get pinCountFailed() {
    return profile.pinCountFailed;
  },
  get latestSetPinFailedAt() {
    return profile.latestSetPinFailedAt;
  }
};

},{"../common/constant":4,"../services/api/user":47}],18:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _organization = _interopRequireDefault(require("../../../services/api/organization"));
var _configuration = _interopRequireDefault(require("../../../services/api/configuration"));
var _userProfile = _interopRequireDefault(require("../../../models/userProfile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  var userOrgId = _userProfile["default"].organizationId;
  var validationSchema = {
    description: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_configName_required
        }
      }
    },
    organizationIds: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_organization_required
        }
      }
    }
  };
  var table = this.find("table").DataTable({
    responsive: true,
    iDisplayLength: 100,
    processing: true,
    serverSide: true,
    lengthChange: false,
    searching: false,
    info: false,
    ordering: false,
    filter: false,
    ajax: function () {
      var _ajax = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(query, callback) {
        var _yield$configurationA, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _configuration["default"].list(query);
            case 3:
              _yield$configurationA = _context.sent;
              data = _yield$configurationA.data;
              data.recordsFiltered = data.recordsTotal;
              callback(data);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              Swal.fire({
                type: "error",
                text: _context.t0.message
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }
      return ajax;
    }(),
    rowId: "id",
    columns: [{
      title: "Configuration ID",
      data: "id"
    }, {
      title: "Configuration Name",
      data: "description"
    }, {
      title: "Organization",
      data: "organizationName"
    }, {
      title: "Action",
      defaultContent: "<button class=\"btn btn-warning btn-sm btn-edit-config\">Edit</button>\n\t\t\t\t<button class=\"btn btn-danger btn-sm btn-delete-config\">Delete</button>"
    }],
    infoCallback: function infoCallback(settings, start, end, max, total) {
      return !isNaN(total) ? "Showing " + start + " to " + end + " of " + total + " entries" + (total !== max ? " (filtered from " + total + " total entries)" : "") : "Showing " + start + " to " + (start + this.api().data().length - 1) + " entries";
    }
  });
  this.find(".jsoneditor-container").each(function () {
    var jsonEditor = new JSONEditor(this, {
      modes: ["text", "code", "tree", "form", "view"],
      mode: "code"
    });
    $(this).data("jsonEditor", jsonEditor).find(".jsoneditor")
    .css({
      display: "flex",
      "flex-direction": "column"
    });
  }).resizable({
    minWidth: 566,
    minHeight: 300
  }).on("resize", function () {
    var jsonEditor = $(this).data("jsonEditor");
    if (jsonEditor.resize) {
      jsonEditor.resize();
    }
  });
  function getJson(editor) {
    try {
      return JSON.stringify(editor.get());
    } catch (error) {
      throw Error("Invalid JSON format");
    }
  }
  function getCreateFormValues() {
    var form = $("#form-create-config");
    return {
      description: form.find('input[name="description"]').val(),
      organizationID: parseInt(userOrgId || form.find('select[name="organizationIds"]').val(), 10),
      jsonValue: getJson(form.find(".jsoneditor-container").data("jsonEditor"))
    };
  }
  function createConfig() {
    return _createConfig.apply(this, arguments);
  }
  function _createConfig() {
    _createConfig = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            formValues = getCreateFormValues();
            _context4.next = 4;
            return _configuration["default"].create(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context4.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.create_config_success
            });
          case 7:
            $("#modal-create-config").modal("hide");
            _context4.next = 13;
            break;
          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            Swal.fire({
              type: "error",
              text: _context4.t0.message
            });
          case 13:
            _context4.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context4.finish(13);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 10, 13, 16]]);
    }));
    return _createConfig.apply(this, arguments);
  }
  $("#form-create-config").bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      createConfig();
      return false;
    }
  });
  function getEditFormValues() {
    var form = $("#form-edit-config");
    return {
      id: parseInt(form.find('input[name="id"]').val(), 10),
      description: form.find('input[name="description"]').val(),
      organizationID: parseInt(userOrgId || form.find('select[name="organizationIds"]').val(), 10),
      jsonValue: getJson(form.find(".jsoneditor-container").data("jsonEditor"))
    };
  }
  function updateConfig() {
    return _updateConfig.apply(this, arguments);
  }
  function _updateConfig() {
    _updateConfig = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            formValues = getEditFormValues();
            _context5.next = 4;
            return _configuration["default"].update(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context5.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.update_config_success
            });
          case 7:
            $("#modal-edit-config").modal("hide");
            _context5.next = 13;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            Swal.fire({
              type: "error",
              text: _context5.t0.message
            });
          case 13:
            _context5.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context5.finish(13);
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 10, 13, 16]]);
    }));
    return _updateConfig.apply(this, arguments);
  }
  $("#form-edit-config").bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      updateConfig();
      return false;
    }
  });
  var organizationSelects = this.find("select[name='organizationIds']");
  if (!userOrgId) {
    _organization["default"].list().then(function (_ref) {
      var data = _ref.data;
      organizationSelects.options(data.data, ["organizationId", "organizationName"]).select2({
        placeholder: "Select Organization"
      });
    });
  } else {
    organizationSelects.parent().hide();
  }
  this.find("#modal-create-config, #modal-edit-config").on("hidden.bs.modal", function () {
    var form = $(this).find("form");
    form.clearForm().find("select").change();
    form.find(".jsoneditor-container").css({
      width: "auto",
      height: "auto"
    }).data("jsonEditor").set({});
  });
  this.on("click", ".btn-edit-config", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var row, _row$data, id, description, organizationId, modalEl, jsonEditor, _yield$configurationA2, jsonValue;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          row = table.row($(this).closest("tr"));
          _row$data = row.data(), id = _row$data.id, description = _row$data.description, organizationId = _row$data.organizationId;
          modalEl = $("#modal-edit-config");
          modalEl.find('input[name="id"]').val(id);
          modalEl.find('input[name="description"]').val(description);
          modalEl.find('select[name="organizationIds"]').val(organizationId).change();
          modalEl.modal("show");
          jsonEditor = modalEl.find(".jsoneditor-container").data("jsonEditor");
          jsonEditor.set("Loading...");
          _context2.next = 12;
          return _configuration["default"].get(id);
        case 12:
          _yield$configurationA2 = _context2.sent;
          jsonValue = _yield$configurationA2.data.jsonValue;
          jsonEditor.set(jsonValue);
          _context2.next = 20;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](0);
          Swal.fire({
            type: "error",
            text: _context2.t0.message
          });
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this, [[0, 17]]);
  })));
  this.on("click", ".btn-delete-config", _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
    var configId, result;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          configId = $(this).closest("tr").attr("id");
          _context3.next = 4;
          return Swal.fire({
            title: errorMessage.message.confirm_delete_organization,
            text: "You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
          });
        case 4:
          result = _context3.sent;
          if (result.value) {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return");
        case 7:
          $(this).loading(true);
          _context3.next = 10;
          return _configuration["default"].remove(configId);
        case 10:
          table.ajax.reload(null, false);
          _context3.next = 13;
          return Swal.fire("Deleted!", errorMessage.message.delete_organization_success, "success");
        case 13:
          _context3.next = 18;
          break;
        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3["catch"](0);
          Swal.fire({
            type: "error",
            text: _context3.t0.message
          });
        case 18:
        case "end":
          return _context3.stop();
      }
    }, _callee3, this, [[0, 15]]);
  })));
}

},{"../../../models/userProfile":17,"../../../services/api/configuration":35,"../../../services/api/organization":42}],19:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _resources = _interopRequireDefault(require("../../../services/api/resources"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var validationSchema = {
  seqNumber: {
    validators: {
      notEmpty: {
        message: "Sequence Number is required"
      }
    }
  },
  displayText: {
    validators: {
      notEmpty: {
        message: "Display Text is required"
      },
      stringLength: {
        max: 50,
        message: "Display Text is must be less than 50 characters"
      }
    }
  },
  linkAddress: {
    validators: {
      notEmpty: {
        message: "Link Address is required"
      }
    }
  },
  fileId: {
    validators: {
      notEmpty: {
        message: "File is required"
      }
    }
  }
};
function _default() {
  var container = this;
  var modalEdit = container.find("#modal-edit-resource");
  var modalTitle = modalEdit.find(".modal-title");
  var formEdit = modalEdit.find("form");
  var table;
  var availableFiles = [];
  function currentMode() {
    return container.find("input[name=resource-mode]:checked").val();
  }
  _resources["default"].list({
    type: "file"
  }).then(function (_ref) {
    var data = _ref.data;
    availableFiles = data || [];
    modalEdit.find("select[name=fileId]").options(availableFiles, function (_ref2) {
      var id = _ref2.id,
        name = _ref2.name;
      return {
        value: id,
        label: name
      };
    }).select2({
      placeholder: "Select a File"
    });
  });
  modalEdit.on("hidden.bs.modal", function () {
    formEdit.clearForm();
    formEdit.data("formData", null);
  }).on("show.bs.modal", function () {
    var mode = currentMode();
    var isNew = !formEdit.find("input[name=".concat(mode === "link" ? "linkAddress" : "fileId", "]")).val();
    modalTitle.text("".concat(isNew ? "Add" : "Edit", " ").concat(mode === "link" ? "Link" : "File"));
    if (mode === "link") {
      modalEdit.find(".mode-link").show();
      modalEdit.find(".mode-file").hide();
    } else {
      modalEdit.find(".mode-link").hide();
      modalEdit.find(".mode-file").show();
    }
    
  });
  this.on("click", "#add-resource-btn", function () {
    modalEdit.modal("show");
  });
  this.on("click", "input[name=resource-mode]", initTable);
  function saveResource() {
    return _saveResource.apply(this, arguments);
  }
  function _saveResource() {
    _saveResource = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var position, displayText, mode, linkAddress, resourceData, fileId, _resourceData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            position = formEdit.find("input[name=seqNumber]").val();
            displayText = formEdit.find("input[name=displayText]").val();
            mode = currentMode();
            if (!(mode === "link")) {
              _context3.next = 16;
              break;
            }
            linkAddress = formEdit.find("input[name=linkAddress]").val();
            resourceData = formEdit.data("formData");
            if (!resourceData) {
              _context3.next = 12;
              break;
            }
            _context3.next = 10;
            return _resources["default"].update(_objectSpread(_objectSpread({}, resourceData), {}, {
              link: linkAddress,
              name: displayText,
              isDisplay: true,
              position: position
            }));
          case 10:
            _context3.next = 14;
            break;
          case 12:
            _context3.next = 14;
            return _resources["default"].create({
              data: linkAddress,
              name: displayText,
              isDisplay: true,
              position: position
            });
          case 14:
            _context3.next = 20;
            break;
          case 16:
            fileId = formEdit.find("select[name=fileId]").val();
            _resourceData = availableFiles.find(function (i) {
              return i.id.toString() === fileId;
            });
            _context3.next = 20;
            return _resources["default"].update(_objectSpread(_objectSpread({}, _resourceData), {}, {
              name: displayText,
              isDisplay: true,
              position: position
            }));
          case 20:
            table.ajax.reload(null, false);
            _context3.next = 23;
            return Swal.fire({
              type: "success",
              text: "Resource successfully saved"
            });
          case 23:
            modalEdit.modal("hide");
            _context3.next = 29;
            break;
          case 26:
            _context3.prev = 26;
            _context3.t0 = _context3["catch"](0);
            Swal.fire({
              type: "error",
              text: _context3.t0.message
            });
          case 29:
            _context3.prev = 29;
            formEdit.find("button[type=submit]").removeAttr("disabled");
            return _context3.finish(29);
          case 32:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 26, 29, 32]]);
    }));
    return _saveResource.apply(this, arguments);
  }
  formEdit.bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      saveResource();
      return false;
    }
  });
  function initTable() {
    var refColumnTitle = currentMode() === "link" ? "Link Address" : "File Name";
    container.on("click", ".btn-edit-resource", function () {
      var row = table.row($(this).parents("tr"));
      var _row$data = row.data(),
        id = _row$data.id,
        position = _row$data.position,
        name = _row$data.name,
        link = _row$data.link;
      formEdit.data("formData", row.data());
      formEdit.find("input[name=seqNumber]").val(position);
      formEdit.find("input[name=displayText]").val(name);
      formEdit.find("input[name=linkAddress]").val(link);
      formEdit.find("select[name=fileId]").val(id).trigger('change');
      modalEdit.modal("show");
    });
    container.on("click", ".btn-delete-resource", _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
      var result, row, resourceData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Swal.fire({
              title: "Do you want to delete this resource?",
              text: "You won't be able to revert this!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, delete it!"
            });
          case 3:
            result = _context.sent;
            if (result.value) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            $(this).loading(true);
            row = table.row($(this).parents("tr"));
            resourceData = row.data();
            _context.next = 11;
            return _resources["default"].update(_objectSpread(_objectSpread({}, resourceData), {}, {
              isDisplay: false
            }));
          case 11:
            table.ajax.reload(null, false);
            Swal.fire({
              type: "success",
              text: "Resource successfully deleted"
            });
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            Swal.fire({
              type: "error",
              text: _context.t0.message
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[0, 15]]);
    })));
    table = container.find("table").DataTable({
      destroy: true,
      responsive: true,
      processing: true,
      serverSide: false,
      lengthChange: true,
      orderCellsTop: true,
      autoWidth: false,
      paging: true,
      searching: false,
      info: false,
      ajax: function ajax(query, callback) {
        _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
          var draw, _yield$resourcesApi$l, data;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                draw = query.draw;
                _context2.next = 4;
                return _resources["default"].list({
                  type: currentMode(),
                  isDisplay: true
                });
              case 4:
                _yield$resourcesApi$l = _context2.sent;
                data = _yield$resourcesApi$l.data;
                callback({
                  data: data,
                  draw: draw,
                  recordsFiltered: data.length,
                  recordsTotal: data.length
                });
                _context2.next = 12;
                break;
              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                Swal.fire({
                  type: "error",
                  text: _context2.t0.message
                });
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 9]]);
        }))();
      },
      rowId: "id",
      columns: [{
        title: "Seq No.",
        data: function data(_ref5) {
          var position = _ref5.position;
          return position;
        },
        width: 60
      }, {
        title: "Resource Type",
        data: function data(_ref6) {
          var type = _ref6.type;
          return type;
        },
        width: 100
      }, {
        title: "Display Text",
        data: function data(_ref7) {
          var name = _ref7.name;
          return name;
        }
      }, {
        title: refColumnTitle,
        data: function data(_ref8) {
          var link = _ref8.link,
            name = _ref8.name;
          return currentMode() === "link" ? "<a class=\"btn-link\" href=\"".concat(link, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(link, "</a>") : name;
        }
      }, {
        title: "Action",
        width: 160,
        data: function data() {
          return "<a class=\"btn btn-warning btn-sm btn-edit-resource\">Edit</a> <a class=\"btn btn-danger btn-sm btn-delete-resource\">Delete</a>";
        }
      }]
    });
  }
  initTable();
}

},{"../../../services/api/resources":45}],20:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _organization = _interopRequireDefault(require("../../../services/api/organization"));
var _group = _interopRequireDefault(require("../../../services/api/group"));
var _userProfile = _interopRequireDefault(require("../../../models/userProfile"));
var _excluded = ["start", "search", "order"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  var userOrgId = _userProfile["default"].organizationId;
  var validationSchema = {
    groupName: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_groupName_required
        }
      }
    },
    organizationIds: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_organization_required
        }
      }
    }
  };
  var table = this.find("table").DataTable({
    responsive: true,
    aLengthMenu: [[10, 20, 50, 100, 200, 1000000], [10, 20, 50, 100, 200, "All"]],
    iDisplayLength: 10,
    processing: true,
    serverSide: true,
    stateSave: true,
    lengthChange: true,
    searching: false,
    ajax: function () {
      var _ajax = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(query, callback) {
        var columnsSearch, startRow, search, order, others, _yield$groupApi$list, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              columnsSearch = ["groupId", "groupName", "organizationId"];
              startRow = query.start, search = query.search, order = query.order, others = _objectWithoutProperties(query, _excluded);
              _context.next = 5;
              return _group["default"].list(_objectSpread(_objectSpread({}, others), {}, {
                startRow: startRow,
                columnsSearch: columnsSearch,
                orderBy: columnsSearch[order[0].column],
                keySearch: search.value,
                orderStatus: order[0].dir
              }));
            case 5:
              _yield$groupApi$list = _context.sent;
              data = _yield$groupApi$list.data;
              data.recordsFiltered = data.recordsTotal;
              callback(data);
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              Swal.fire({
                type: "error",
                text: _context.t0.message
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 11]]);
      }));
      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }
      return ajax;
    }(),
    rowId: "id",
    columns: [{
      title: "Group ID",
      data: "id"
    }, {
      title: "Group Name",
      data: "groupName"
    }, {
      title: "Organization",
      data: "organizationName"
    }, {
      title: "Action",
      orderable: false,
      defaultContent: "<button class=\"btn btn-warning btn-sm btn-edit-group\">Edit</button>\n          <button class=\"btn btn-danger btn-sm btn-delete-group\">Delete</button>"
    }],
    infoCallback: function infoCallback(settings, start, end, max, total) {
      return !isNaN(total) ? "Showing " + start + " to " + end + " of " + total + " entries" + (total !== max ? " (filtered from " + total + " total entries)" : "") : "Showing " + start + " to " + (start + this.api().data().length - 1) + " entries";
    }
  });
  function getCreateFormValues() {
    var form = $("#form-create-group");
    return {
      groupName: form.find('input[name="groupName"]').val(),
      organizationID: parseInt(userOrgId || form.find('select[name="organizationIds"]').val(), 10)
    };
  }
  function createGroup() {
    return _createGroup.apply(this, arguments);
  }
  function _createGroup() {
    _createGroup = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            formValues = getCreateFormValues();
            _context3.next = 4;
            return _group["default"].create(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context3.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.create_group_success
            });
          case 7:
            $("#modal-create-group").modal("hide");
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            Swal.fire({
              type: "error",
              text: _context3.t0.message
            });
          case 13:
            _context3.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context3.finish(13);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 10, 13, 16]]);
    }));
    return _createGroup.apply(this, arguments);
  }
  $("#form-create-group").bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      createGroup();
      return false;
    }
  });
  function getEditFormValues() {
    var form = $("#form-edit-group");
    return {
      groupID: parseInt(form.find('input[name="groupID"]').val(), 10),
      groupName: form.find('input[name="groupName"]').val(),
      organizationID: parseInt(userOrgId || form.find('select[name="organizationIds"]').val(), 10)
    };
  }
  function updateGroup() {
    return _updateGroup.apply(this, arguments);
  }
  function _updateGroup() {
    _updateGroup = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            formValues = getEditFormValues();
            _context4.next = 4;
            return _group["default"].update(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context4.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.update_group_success
            });
          case 7:
            $("#modal-edit-group").modal("hide");
            _context4.next = 13;
            break;
          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            Swal.fire({
              type: "error",
              text: _context4.t0.message
            });
          case 13:
            _context4.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context4.finish(13);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 10, 13, 16]]);
    }));
    return _updateGroup.apply(this, arguments);
  }
  $("#form-edit-group").bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      updateGroup();
      return false;
    }
  });
  var organizationSelects = this.find("select[name='organizationIds']");
  if (!userOrgId) {
    _organization["default"].list().then(function (_ref) {
      var data = _ref.data;
      organizationSelects.options(data.data, ["organizationId", "organizationName"]).select2({
        placeholder: "Select Organization"
      });
    });
  } else {
    organizationSelects.parent().hide();
  }
  this.find("#modal-create-group, #modal-edit-group").on("hidden.bs.modal", function () {
    $(this).find("form").clearForm().find("select").change();
  });
  this.on("click", ".btn-edit-group", function () {
    var row = table.row($(this).closest("tr"));
    var _row$data = row.data(),
      id = _row$data.id,
      groupName = _row$data.groupName,
      organizationId = _row$data.organizationId;
    var modalEl = $("#modal-edit-group");
    modalEl.find('input[name="groupID"]').val(id);
    modalEl.find('input[name="groupName"]').val(groupName);
    modalEl.find('select[name="organizationIds"]').val(organizationId).change();
    modalEl.modal("show");
  });
  this.on("click", ".btn-delete-group", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var result, groupId;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Swal.fire({
            title: errorMessage.message.confirm_delete_group,
            text: "You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
          });
        case 3:
          result = _context2.sent;
          if (result.value) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          $(this).loading(true);
          groupId = $(this).closest("tr").attr("id");
          _context2.next = 10;
          return _group["default"].remove(groupId);
        case 10:
          table.ajax.reload(null, false);
          Swal.fire("Deleted!", errorMessage.message.delete_group_success, "success");
          _context2.next = 17;
          break;
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](0);
          Swal.fire({
            type: "error",
            text: _context2.t0.message
          });
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this, [[0, 14]]);
  })));
}

},{"../../../models/userProfile":17,"../../../services/api/group":39,"../../../services/api/organization":42}],21:[function(require,module,exports){
(function (global){(function (){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _message = _interopRequireDefault(require("../../../services/api/message"));
var _excluded = ["start"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  var table = this.find("table").DataTable({
    responsive: true,
    aLengthMenu: [[10, 20, 50, 100, 200, 1000000], [10, 20, 50, 100, 200, "All"]],
    iDisplayLength: 10,
    processing: true,
    serverSide: true,
    lengthChange: true,
    orderCellsTop: true,
    autoWidth: false,
    paging: true,
    searching: false,
    ajax: function () {
      var _ajax = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(query, callback) {
        var startRow, others, _yield$messageApi$lis, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              startRow = query.start, others = _objectWithoutProperties(query, _excluded);
              _context.next = 4;
              return _message["default"].list(_objectSpread(_objectSpread({}, others), {}, {
                startRow: startRow
              }));
            case 4:
              _yield$messageApi$lis = _context.sent;
              data = _yield$messageApi$lis.data;
              data.data = data.rows;
              data.recordsFiltered = data.count;
              delete data["rows"];
              delete data["count"];
              callback(data);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              Swal.fire({
                type: "error",
                text: _context.t0.message
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }));
      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }
      return ajax;
    }(),
    rowId: "id",
    columns: [{
      title: "Seq.",
      data: function data() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return args[3].row + 1;
      }
    }, {
      title: "Content",
      data: "content"
    }, {
      title: "Sent time",
      className: "text-nowrap",
      data: function data(_data) {
        return Utils.convertFromUtcFormat(_.get(_data, "createdAt", ""), global.userProfile.timezone || DEFAULT_TIME_ZONE, FORMAT_TIME_UI);
      }
    }, {
      title: "Sent from",
      className: "text-nowrap",
      data: "AspNetUsers.userName"
    }, {
      title: "Details",
      defaultContent: "<a class=\"btn btn-link no-padding view-details-btn\">View</a>",
      orderable: false,
      className: "text-center"
    }],
    infoCallback: function infoCallback(settings, start, end, max, total) {
      return !isNaN(total) ? "Showing " + start + " to " + end + " of " + total + " entries" + (total !== max ? " (filtered from " + total + " total entries)" : "") : "Showing " + start + " to " + (start + this.api().data().length - 1) + " entries";
    }
  });
  this.on("click", ".view-details-btn", function (event) {
    event.preventDefault();
    var row = table.row($(this).closest("tr"));
    var data = row.data();
    var content = [{
      label: "Sent time",
      text: Utils.convertFromUtcFormat(_.get(data, "createdAt", ""), global.userProfile.timezone, FORMAT_TIME_UI)
    }, {
      label: "Sent from",
      text: _.get(data, "AspNetUsers.userName", "")
    }, {
      label: "Sent to",
      text: _.get(data, "Organizations.organizationName", "")
    }, {
      label: "Message",
      text: _.get(data, "content", "").replace(/(?:\r\n|\r|\n)/g, "<br />")
    }].map(function (_ref) {
      var label = _ref.label,
        text = _ref.text;
      return "<div class=\"mt-8 mb-8\"><b>".concat(label, ":</b> ").concat(text, "</div>");
    }).join("");
    Swal.fire({
      html: "<div class=\"text-left pl-10 mt-10 mb-10\" style=\"font-size: 1.2em\">".concat(content, "</div>"),
      showCloseButton: true,
      showConfirmButton: false,
      width: "40rem"
    });
  });
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../../services/api/message":41}],22:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _organization = _interopRequireDefault(require("../../../services/api/organization"));
var _common = _interopRequireDefault(require("../../../services/api/common"));
var _excluded = ["start", "search", "order"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  var _this = this;
  var defaultTimeZone = "Pacific Standard Time";
  var validationSchema = {
    organizationName: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_organizationName_required
        }
      }
    }
  };
  var table = this.find("table").DataTable({
    responsive: true,
    dom: "lBfrtip",
    aLengthMenu: [[10, 20, 50, 100, 200, 1000000], [10, 20, 50, 100, 200, "All"]],
    iDisplayLength: 10,
    processing: true,
    serverSide: true,
    stateSave: true,
    lengthChange: true,
    searching: false,
    ajax: function () {
      var _ajax = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(query, callback) {
        var columnsSearch, startRow, search, order, others, _yield$organizationAp, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              columnsSearch = ["organizationId", "organizationName", "timeZone"];
              startRow = query.start, search = query.search, order = query.order, others = _objectWithoutProperties(query, _excluded);
              _context.next = 5;
              return _organization["default"].list(_objectSpread(_objectSpread({}, others), {}, {
                startRow: startRow,
                columnsSearch: columnsSearch,
                orderBy: columnsSearch[order[0].column],
                keySearch: search.value,
                orderStatus: order[0].dir
              }));
            case 5:
              _yield$organizationAp = _context.sent;
              data = _yield$organizationAp.data;
              data.recordsFiltered = data.recordsTotal;
              callback(data);
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              Swal.fire({
                type: "error",
                text: _context.t0.message
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 11]]);
      }));
      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }
      return ajax;
    }(),
    rowId: "organizationId",
    columns: [{
      title: "Organization ID",
      data: "organizationId"
    }, {
      title: "Organization Name",
      data: "organizationName"
    }, {
      title: "Time Zone",
      data: "timeZone"
    }, {
      title: "Action",
      orderable: false,
      defaultContent: "<button class=\"btn btn-warning btn-sm btn-edit-organization\">Edit</button>\n            <button class=\"btn btn-danger btn-sm btn-delete-organization\">Delete</button>"
    }],
    infoCallback: function infoCallback(settings, start, end, max, total) {
      return !isNaN(total) ? "Showing " + start + " to " + end + " of " + total + " entries" + (total !== max ? " (filtered from " + total + " total entries)" : "") : "Showing " + start + " to " + (start + this.api().data().length - 1) + " entries";
    }
  });
  function getCreateFormValues() {
    var form = $("#form-create-organization");
    return {
      organizationName: form.find('input[name="organizationName"]').val(),
      timeZone: form.find('select[name="timeZone"]').val()
    };
  }
  function createOrganization() {
    return _createOrganization.apply(this, arguments);
  }
  function _createOrganization() {
    _createOrganization = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            formValues = getCreateFormValues();
            _context3.next = 4;
            return _organization["default"].create(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context3.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.create_organization_success
            });
          case 7:
            $("#modal-create-organization").modal("hide");
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            Swal.fire({
              type: "error",
              text: _context3.t0.message
            });
          case 13:
            _context3.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context3.finish(13);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 10, 13, 16]]);
    }));
    return _createOrganization.apply(this, arguments);
  }
  $("#form-create-organization").bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      createOrganization();
      return false;
    }
  });
  function getEditFormValues() {
    var form = $("#form-edit-organization");
    return {
      organizationName: form.find('input[name="organizationName"]').val(),
      organizationId: parseInt(form.find('input[name="organizationId"]').val(), 10),
      timeZone: form.find('select[name="timeZone"]').val()
    };
  }
  function updateOrganization() {
    return _updateOrganization.apply(this, arguments);
  }
  function _updateOrganization() {
    _updateOrganization = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            formValues = getEditFormValues();
            _context4.next = 4;
            return _organization["default"].update(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context4.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.update_organization_success
            });
          case 7:
            $("#modal-edit-organization").modal("hide");
            _context4.next = 13;
            break;
          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            Swal.fire({
              type: "error",
              text: _context4.t0.message
            });
          case 13:
            _context4.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context4.finish(13);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 10, 13, 16]]);
    }));
    return _updateOrganization.apply(this, arguments);
  }
  $("#form-edit-organization").bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      updateOrganization();
      return false;
    }
  });
  _common["default"].getTimeZones().then(function (_ref) {
    var _data;
    var data = _ref.data;
    data = (_data = data) === null || _data === void 0 ? void 0 : _data.map(function (item) {
      return {
        id: item,
        displayName: item
      };
    });
    _this.find("select[name='timeZone']").options(data, ["id", "displayName"]).select2();
  });
  this.find("#modal-create-organization, #modal-edit-organization").on("hidden.bs.modal", function () {
    $(this).find("form").clearForm().find("select").change();
  }).filter(function () {
    return this.id.includes("create");
  }).on("show.bs.modal", function () {
    $(this).find("select[name=timeZone]").val(defaultTimeZone).change();
  });
  this.on("click", ".btn-edit-organization", function () {
    var row = table.row($(this).closest("tr"));
    var _row$data = row.data(),
      organizationId = _row$data.organizationId,
      organizationName = _row$data.organizationName,
      timeZone = _row$data.timeZone;
    var modalEl = $("#modal-edit-organization");
    modalEl.find('input[name="organizationName"]').val(organizationName);
    modalEl.find('input[name="organizationId"]').val(organizationId);
    modalEl.find('select[name="timeZone"]').val(timeZone).change();
    modalEl.modal("show");
  });
  this.on("click", ".btn-delete-organization", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var organizationId, result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          organizationId = $(this).closest("tr").attr("id");
          _context2.next = 4;
          return Swal.fire({
            title: errorMessage.message.confirm_delete_organization,
            text: "You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
          });
        case 4:
          result = _context2.sent;
          if (result.value) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return");
        case 7:
          $(this).loading(true);
          _context2.next = 10;
          return _organization["default"].remove(organizationId);
        case 10:
          table.ajax.reload(null, false);
          Swal.fire("Deleted!", errorMessage.message.delete_organization_success, "success");
          _context2.next = 17;
          break;
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](0);
          Swal.fire({
            type: "error",
            text: _context2.t0.message
          });
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this, [[0, 14]]);
  })));
}

},{"../../../services/api/common":34,"../../../services/api/organization":42}],23:[function(require,module,exports){
(function (global){(function (){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _userProfile = _interopRequireDefault(require("../../../models/userProfile"));
var _organization = _interopRequireDefault(require("../../../services/api/organization"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  this.find("#org-name").text(_userProfile["default"].organizationName);
  function disableEditPinCheck(value) {
    $("#edit-pin").prop("disabled", value);
  }
  function getPin() {
    return _getPin.apply(this, arguments);
  }
  function _getPin() {
    _getPin = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var _global$organization, isRequiredPinAllUser, pinLength;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            try {
              _global$organization = global.organization, isRequiredPinAllUser = _global$organization.isRequiredPinAllUser, pinLength = _global$organization.pinLength;
              enablePin.next(isRequiredPinAllUser);
              hasOldPin.next(!!pinLength);
              initialState.enablePin = isRequiredPinAllUser;
              initialState.hasOldPin = !!pinLength;
              $('input[name="pin"]').val("*".repeat(pinLength));
            } catch (err) {
              
            }
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _getPin.apply(this, arguments);
  }
  var initialState = {
    enablePin: false,
    hasOldPin: false
  };
  var enablePin = new rxjs.BehaviorSubject(false);
  var pinEditing = new rxjs.BehaviorSubject(false);
  var hasOldPin = new rxjs.BehaviorSubject(false);
  var showPin = new rxjs.BehaviorSubject({});
  getPin();
  function initPinFormValidation() {
    $("#pin-form").bootstrapValidator("destroy").bootstrapValidator({
      fields: {
        oldPin: {
          validators: {
            notEmpty: {
              message: "Enter current PIN number"
            },
            remote: {
              message: "PIN is incorrect!",
              runCallback: function runCallback($field, options) {
                var value = $field.val(),
                  dfd = new $.Deferred();
                if (value.length < global.organization.pinLength) {
                  dfd.resolve($field, "remote", {
                    valid: false
                  });
                  return dfd;
                }
                var requestData = {
                  organizationId: _userProfile["default"].organizationId,
                  pin: value
                };
                _organization["default"].authenticatePin(requestData).then(function (response) {
                  dfd.resolve($field, "remote", {
                    valid: true
                  });
                })["catch"](function () {
                  dfd.resolve($field, "remote", {
                    valid: false
                  });
                });
                return dfd;
              }
            }
          }
        },
        pin: {
          validators: {
            notEmpty: {
              message: "Enter new PIN number"
            }
          }
        },
        confirmPin: {
          validators: {
            notEmpty: {
              message: "Confirm your PIN number"
            },
            identical: {
              field: "pin",
              message: "PIN doesn’t match"
            }
          }
        }
      },
      onSuccess: function () {
        var _onSuccess = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(e) {
          var requestData;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _context.prev = 1;
                requestData = {
                  organizationId: _userProfile["default"].organizationId,
                  organizationName: _userProfile["default"].organizationName,
                  timeZone: _userProfile["default"].timezone,
                  isRequiredPinAllUser: $("#enable-pin:checked").length > 0,
                  pin: $('input[name="pin"]').val()
                };
                _context.next = 5;
                return _organization["default"].update(requestData);
              case 5:
                requestData.pin && hasOldPin.next(requestData.pin);
                pinEditing.next(false);
                $('input[name="pin"]').val("*".repeat(requestData.pin.length));
                disableEditPinCheck(false);
                Swal.fire({
                  type: "success",
                  title: "Set PIN successfully"
                });
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                Swal.fire({
                  type: "error",
                  title: "Set PIN unsuccessfully"
                });
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 12]]);
        }));
        function onSuccess(_x) {
          return _onSuccess.apply(this, arguments);
        }
        return onSuccess;
      }()
    });
  }
  $("input[type='password']").on("keypress", function (e) {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  });
  function updateEnablePin(_x2) {
    return _updateEnablePin.apply(this, arguments);
  }
  function _updateEnablePin() {
    _updateEnablePin = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(checked) {
      var requestData;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            requestData = {
              organizationId: _userProfile["default"].organizationId,
              organizationName: _userProfile["default"].organizationName,
              timeZone: _userProfile["default"].timezone,
              isRequiredPinAllUser: checked
            };
            _context4.next = 4;
            return _organization["default"].update(requestData);
          case 4:
            enablePin.next(checked);
            if (checked && !hasOldPin.value) {
              pinEditing.next(true);
            }
            Swal.fire({
              type: "success",
              title: "".concat(checked ? "Enable" : "Disable", " PIN successfully")
            });
            _context4.next = 12;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            Swal.fire({
              type: "error",
              title: "".concat(checked ? "Enable" : "Disable", " PIN unsuccessfully")
            });
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 9]]);
    }));
    return _updateEnablePin.apply(this, arguments);
  }
  enablePin.subscribe(function (value) {
    $("#enable-pin").prop("checked", value);
  });
  $("#enable-pin").on("change", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var checked, result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          checked = this.checked; 
          $(this).prop("checked", !this.checked);
          if (checked) {
            _context2.next = 10;
            break;
          }
          _context2.next = 5;
          return Swal.fire({
            type: "warning",
            title: "You're turning off PIN",
            text: "All users won't be required PIN to access the system",
            confirmButtonText: "Yes, disable PIN",
            showCancelButton: true
          });
        case 5:
          result = _context2.sent;
          if (result.value) {
            updateEnablePin(checked);
          }
          checked = !result.value;
          _context2.next = 11;
          break;
        case 10:
          updateEnablePin(checked);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this);
  })));
  pinEditing.subscribe(function (value) {
    $("#edit-pin").prop("checked", value);
    var inputs = $("#pin-form").find("input");
    inputs.prop("disabled", !value);
    inputs.val("");
    if (!value) {
      $('input[name="pin"]').val("*".repeat(hasOldPin.value.length));
      showPin.next({});
      initPinFormValidation();
      $(".group-action-btn").hide();
    } else {
      $(".group-action-btn").show();
    }
  });
  $("#edit-pin").on("change", function () {
    pinEditing.next(this.checked);
    var inputs = $("#pin-form").find("input");
    inputs.prop("disabled", !this.checked);
  });
  hasOldPin.subscribe(function (value) {
    if (value) {
      $("#old-pin-group").show();
    } else {
      $("#old-pin-group").hide();
    }
  });
  this.find(".pin-settings .submit-btn").on("click", function () {
    $("#pin-form").bootstrapValidator("validate");
    initialState.enablePin = enablePin.value;
    initialState.hasOldPin = hasOldPin.value;
  });
  this.find(".pin-settings .cancel-btn").on("click", function () {
    enablePin.next(initialState.enablePin);
    hasOldPin.next(initialState.hasOldPin);
    pinEditing.next(false);
    showPin.next({});
  });
  showPin.subscribe(function (value) {
    $(".pin-form .input-group-addon").each(function () {
      var icon = $(this);
      var input = icon.prev();
      var name = input.prop("name");
      if (!value[name]) {
        input.prop("type", "password");
        icon.find("i").addClass("fa-eye-slash").removeClass("fa-eye");
      } else {
        input.prop("type", "text");
        icon.find("i").addClass("fa-eye").removeClass("fa-eye-slash");
      }
    });
  });
  $(".input-group-addon").on("click", function () {
    if (!pinEditing.value) {
      return;
    }
    var name = $(this).prev().prop("name");
    var prevValue = showPin.value;
    showPin.next(_objectSpread(_objectSpread({}, prevValue), {}, _defineProperty({}, name, !prevValue[name])));
  });
}
(function ($) {
  $.fn.bootstrapValidator.i18n.remote = $.extend($.fn.bootstrapValidator.i18n.remote || {}, {
    'default': 'Please enter a valid value'
  });
  $.fn.bootstrapValidator.validators.remote = {
    html5Attributes: {
      message: 'message',
      name: 'name',
      type: 'type',
      url: 'url',
      delay: 'delay'
    },
    destroy: function destroy(validator, $field, options) {
      if ($field.data('bv.remote.timer')) {
        clearTimeout($field.data('bv.remote.timer'));
        $field.removeData('bv.remote.timer');
      }
    },
    validate: function validate(validator, $field, options) {
      var value = $field.val(),
        dfd = new $.Deferred();
      if (value === '') {
        dfd.resolve($field, 'remote', {
          valid: true
        });
        return dfd;
      }
      var name = $field.attr('data-bv-field'),
        data = options.data || {},
        url = options.url,
        type = options.type || 'GET',
        headers = options.headers || {};

      if ('function' === typeof data) {
        data = data.call(this, validator);
      }

      if ('function' === typeof url) {
        url = url.call(this, validator);
      }
      data[options.name || name] = value;
      if (options.runCallback) {
        return options.runCallback($field, options);
      }
      function runCallback() {
        var xhr = $.ajax({
          type: type,
          headers: headers,
          url: url,
          dataType: 'json',
          data: data
        });
        xhr.then(function (response) {
          response.valid = response.valid === true || response.valid === 'true';
          dfd.resolve($field, 'remote', response);
        });
        dfd.fail(function () {
          xhr.abort();
        });
        return dfd;
      }
      if (options.delay) {
        if ($field.data('bv.remote.timer')) {
          clearTimeout($field.data('bv.remote.timer'));
        }
        $field.data('bv.remote.timer', setTimeout(runCallback, options.delay));
        return dfd;
      } else {
        return runCallback();
      }
    }
  };
})(window.jQuery);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../../models/userProfile":17,"../../../services/api/organization":42}],24:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _resources = _interopRequireDefault(require("../../../services/api/resources"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var validationSchema = {
  avatar: {
    validators: {
      notEmpty: {
        message: "Please select a file to upload"
      },
      file: {
        maxSize: 5000000,
        message: "File size exceeds 5MB. Please choose another file."
      }
    }
  },
  fileName: {
    validators: {
      notEmpty: {
        message: "File Name is required"
      }
    }
  }
};
function _default() {
  var modalEdit = this.find("#modal-edit-file");
  var formEdit = modalEdit.find("form");
  modalEdit.on("hidden.bs.modal", function () {
    $(this).find("form").clearForm();
  });
  var table = this.find("table").DataTable({
    responsive: true,
    processing: true,
    serverSide: true,
    lengthChange: true,
    orderCellsTop: true,
    autoWidth: false,
    paging: false,
    searching: false,
    info: false,
    ajax: function () {
      var _ajax = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(query, callback) {
        var draw, _yield$resourcesApi$l, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              draw = query.draw;
              _context.next = 4;
              return _resources["default"].list({
                type: "file"
              });
            case 4:
              _yield$resourcesApi$l = _context.sent;
              data = _yield$resourcesApi$l.data;
              callback({
                data: data,
                draw: draw,
                recordsFiltered: data.length,
                recordsTotal: data.length
              });
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              Swal.fire({
                type: "error",
                text: _context.t0.message
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }
      return ajax;
    }(),
    rowId: "id",
    columns: [{
      title: "Seq",
      data: function data() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return args[3].row + 1;
      }
    }, {
      title: "File name",
      data: function data(_ref) {
        var name = _ref.name;
        return name;
      }
    }, {
      title: "Action",
      defaultContent: "<a class=\"btn btn-danger btn-sm btn-delete-file\">Delete</a>"
    }]
  });
  this.on("click", ".btn-delete-file", _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var result, id;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Swal.fire({
            title: "Do you want to delete this file?",
            text: "You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
          });
        case 3:
          result = _context2.sent;
          if (result.value) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          $(this).loading(true);
          id = $(this).parents("tr").attr("id");
          _context2.next = 10;
          return _resources["default"].remove(id);
        case 10:
          table.ajax.reload(null, false);
          _context2.next = 13;
          return Swal.fire("Deleted!", "File successfully deleted", "success");
        case 13:
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](0);
          Swal.fire({
            type: "error",
            text: _context2.t0.message
          });
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this, [[0, 15]]);
  })));
  function saveFile() {
    return _saveFile.apply(this, arguments);
  }
  function _saveFile() {
    _saveFile = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var files, fileName;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            files = formEdit.find("#input-file").prop("files");
            fileName = modalEdit.find("#input-file-name").val();
            _context3.next = 5;
            return _resources["default"].create({
              data: files[0],
              name: fileName,
              isDisplay: false
            });
          case 5:
            table.ajax.reload(null, false);
            _context3.next = 8;
            return Swal.fire({
              type: "success",
              text: "File successfully uploaded"
            });
          case 8:
            modalEdit.modal("hide");
            _context3.next = 14;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            Swal.fire({
              type: "error",
              text: _context3.t0.message
            });
          case 14:
            _context3.prev = 14;
            formEdit.find("button[type=submit]").removeAttr("disabled");
            return _context3.finish(14);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 11, 14, 17]]);
    }));
    return _saveFile.apply(this, arguments);
  }
  formEdit.bootstrapValidator({
    fields: validationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      saveFile();
      return false;
    }
  });
}

},{"../../../services/api/resources":45}],25:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _organization = _interopRequireDefault(require("../../../services/api/organization"));
var _user = _interopRequireDefault(require("../../../services/api/user"));
var _group = _interopRequireDefault(require("../../../services/api/group"));
var _constant = require("../../../common/constant");
var _userProfile = _interopRequireDefault(require("../../../models/userProfile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _default() {
  var userOrgId = _userProfile["default"].organizationId;
  var userOrgName = _userProfile["default"].organizationName;
  var currentRole = _userProfile["default"].role;
  var currentTimezone = _userProfile["default"].timezone;
  var userFieldsValidationSchema = {
    email: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_email_required
        },
        emailAddress: {
          message: errorMessage.error.validate_email_invalid
        }
      }
    },
    userName: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_userName_required
        }
      }
    },
    firstName: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_firstName_required
        }
      }
    },
    lastName: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_lastName_required
        }
      }
    },
    organizationIds: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_organization_required,
          enabled: false
        },
        callback: {
          message: errorMessage.error.validate_organization_required,
          callback: function callback(value) {
            var roleType = $("input[name='userType']").filter(":checked").val();
            if ([_constant.UserRole.SUPER_ADMIN].includes(roleType) || !roleType) {
              return true;
            }
            return !!value;
          }
        }
      }
    },
    groupIds: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_group_required,
          enabled: false
        }
      }
    },
    password: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_password_required
        },
        stringLength: {
          min: 6,
          max: 50,
          message: errorMessage.error.validate_password_minimum
        }
      }
    },
    confirmPassword: {
      validators: {
        notEmpty: {
          message: errorMessage.error.validate_confirmPassword_matched
        },
        identical: {
          field: "password",
          message: errorMessage.error.validate_confirmPassword_matched
        }
      }
    }
  };
  function getItemActions() {
    var actions = [{
      "class": "btn-reset-password",
      label: "Reset Password"
    }, {
      "class": "btn-un-pin",
      label: "Unlock User",
      allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN, _constant.UserRole.ORG_SUPERVISOR]
    }, {
      "class": "btn-edit-user",
      label: "Edit",
      allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN]
    }, {
      "class": "btn-delete-user",
      label: "Delete",
      allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN]
    }].map(function (action) {
      return "<li data-role-access=\"".concat(action.allow || [], "\"><a href=\"#\" class=\"").concat(action["class"], "\">").concat(action.label, "</a></li>");
    }).join("");
    return "\n    <div class=\"dropdown\">\n      <button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n        Action\n        <span class=\"caret\" />\n      </button>\n      <ul class=\"dropdown-menu dropdown-menu-right\">\n        ".concat(actions, "\n      </ul>\n    </div>\n  ");
  }
  this.find("#btn-add-user-wrapper").enforceRoleAccess(currentRole);
  this.on("show.bs.dropdown", "tr .dropdown", function () {
    $(this).find("ul").children().enforceRoleAccess(currentRole);
  });
  var optionsTable = [{
    title: "Email",
    data: "email",
    name: "email"
  }, {
    title: "Username",
    data: "userName",
    name: "userName",
    width: "120px"
  }, {
    title: "Status",
    data: "activityStatus",
    width: "60px",
    defaultContent: "",
    name: "activityStatus"
  }, {
    title: "Last Active",
    data: function data(_ref) {
      var latestLoginAt = _ref.latestLoginAt;
      return latestLoginAt ? moment.tz(latestLoginAt, currentTimezone).format("MM/DD/YYYY HH:mm") : "";
    },
    name: "latestLoginAt"
  }, {
    title: "First Name",
    data: "firstName",
    name: "firstName"
  }, {
    title: "Last Name",
    data: "lastName",
    name: "lastName"
  }, {
    title: "Organization",
    data: function data(_ref2) {
      var additionalInfo = _ref2.additionalInfo;
      return _.get(additionalInfo, "organizations.organizationName", "");
    },
    name: "organizationName"
  }, {
    title: "Role",
    data: function data(_ref3) {
      var userRole = _ref3.userRole;
      return _.get(userRole, "roleName", "");
    },
    name: "roleName",
    width: "150px"
  }, {
    title: "Action",
    orderable: false,
    name: "action",
    data: function data(_ref4) {
      var userRole = _ref4.userRole;
      return !(_userProfile["default"].role === _constant.UserRole.ORG_SUPERVISOR && (userRole === null || userRole === void 0 ? void 0 : userRole.roleName) === _constant.UserRole.ORG_ADMIN) ? getItemActions() : "";
    }
  }];
  if (_.toNumber(window.ENV.GROUP_DISABLE) === 0) {
    optionsTable = [].concat(_toConsumableArray(optionsTable), [{
      title: "Group",
      data: function data(_ref5) {
        var additionalInfo = _ref5.additionalInfo;
        return _.get(additionalInfo, "groups", []).map(function (g) {
          return g.groupName;
        }).join(", ");
      },
      name: "groupName",
      width: "120px"
    }]);
  }
  var table = this.find("table").DataTable({
    responsive: true,
    aLengthMenu: [[10, 20, 50, 100, 200, 1000000], [10, 20, 50, 100, 200, "All"]],
    iDisplayLength: 10,
    processing: true,
    serverSide: true,
    lengthChange: true,
    orderCellsTop: true,
    autoWidth: false,
    paging: true,
    ajax: function () {
      var _ajax = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(query, callback) {
        var _yield$userApi$list, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _user["default"].list(query);
            case 3:
              _yield$userApi$list = _context.sent;
              data = _yield$userApi$list.data;
              data.recordsFiltered = data.recordsTotal;
              callback(data);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              Swal.fire({
                type: "error",
                text: _context.t0.message
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      function ajax(_x, _x2) {
        return _ajax.apply(this, arguments);
      }
      return ajax;
    }(),
    rowId: "id",
    columns: optionsTable,
    infoCallback: function infoCallback(settings, start, end, max, total) {
      return !isNaN(total) ? "Showing " + start + " to " + end + " of " + total + " entries" + (total !== max ? " (filtered from " + total + " total entries)" : "") : "Showing " + start + " to " + (start + this.api().data().length - 1) + " entries";
    }
  });

  this.find("#user-list-table_filter").hide();
  this.find("#user-list-table thead tr").clone(true).appendTo("#user-list-table thead").find("th").each(function (i) {
    var title = $(this).text();
    if (!["action", "status", "last active"].includes(title.toLowerCase())) {
      $(this).html('<input type="text" class="form-control" />');
      $(this).removeClass("sorting");
    } else {
      $(this).html("");
      $(this).removeClass("sorting");
    }
    $("input", this).on("keyup change", _.debounce(function () {
      if (table.column(i).search() !== this.value) {
        table.column(i).search(this.value).draw();
      }
    }, 500));
    $(this).unbind("click");
  });
  function getCreateFormValues() {
    var form = $("#form-create-user");
    var organizationSelect = form.find('select[name="organizationIds"]');
    var organizationIds = [_.toNumber(organizationSelect.val())].filter(Boolean);
    var groupSelects = form.find('select[name="groupIds"]');
    var groupIds = groupSelects.val() ? groupSelects.val().map(function (groupId) {
      return parseInt(groupId, 10);
    }) : [];
    return {
      userType: form.find('input[name="userType"]:checked').val(),
      email: form.find('input[name="email"]').val(),
      userName: form.find('input[name="userName"]').val(),
      firstName: form.find('input[name="firstName"]').val(),
      lastName: form.find('input[name="lastName"]').val(),
      password: form.find('input[name="password"]').val(),
      confirmPassword: form.find('input[name="confirmPassword"]').val(),
      defaultPSAPID: form.find('input[name="defaultPSAPID"]').val(),
      organizationIds: organizationIds,
      groupIds: groupIds
    };
  }
  function createUser() {
    return _createUser.apply(this, arguments);
  }
  function _createUser() {
    _createUser = _asyncToGenerator(_regeneratorRuntime().mark(function _callee6() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            formValues = getCreateFormValues();
            _context6.next = 4;
            return _user["default"].create(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context6.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.create_user_success
            });
          case 7:
            $("#modal-create-user").modal("hide");
            _context6.next = 13;
            break;
          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            Swal.fire({
              type: "error",
              text: _context6.t0.message
            });
          case 13:
            _context6.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context6.finish(13);
          case 16:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 10, 13, 16]]);
    }));
    return _createUser.apply(this, arguments);
  }
  $("#form-create-user").bootstrapValidator({
    excluded: ':disabled',
    fields: userFieldsValidationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      $("#form-create-user").bootstrapValidator('revalidateField', 'organizationIds');
      return false;
    }
  }).on('submit', function (e) {
    e.preventDefault();
    $("#form-create-user").bootstrapValidator('revalidateField', 'organizationIds');
    return false;
  }).on('success.form.bv', function (e, data) {
    e.preventDefault();
    if (!$(e.target).find('.has-error').length) {
      createUser();
    }
    return false;
  });
  ;
  function getEditFormValues() {
    var form = $("#form-edit-user");
    var organizationSelect = form.find('select[name="organizationIds"]');
    var organizationIds = [_.toNumber(organizationSelect.val())].filter(Boolean);
    var groupSelects = form.find('select[name="groupIds"]');
    var groupIds = (groupSelects.val() || []).map(function (groupId) {
      return parseInt(groupId, 10);
    });
    return {
      id: form.find('input[name="id"]').val(),
      userType: form.find('input[name="userType"]:checked').val(),
      email: form.find('input[name="email"]').val(),
      userName: form.find('input[name="userName"]').val(),
      firstName: form.find('input[name="firstName"]').val(),
      lastName: form.find('input[name="lastName"]').val(),
      defaultPSAPID: form.find('input[name="defaultPSAPID"]').val(),
      organizationIds: organizationIds,
      groupIds: groupIds
    };
  }
  function updateUser() {
    return _updateUser.apply(this, arguments);
  }
  function _updateUser() {
    _updateUser = _asyncToGenerator(_regeneratorRuntime().mark(function _callee7() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            formValues = getEditFormValues();
            _context7.next = 4;
            return _user["default"].update(formValues);
          case 4:
            table.ajax.reload(null, false);
            _context7.next = 7;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.update_user_success
            });
          case 7:
            $("#modal-edit-user").modal("hide");
            _context7.next = 13;
            break;
          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](0);
            Swal.fire({
              type: "error",
              text: _context7.t0.message
            });
          case 13:
            _context7.prev = 13;
            $("button[type=submit]").removeAttr("disabled");
            return _context7.finish(13);
          case 16:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[0, 10, 13, 16]]);
    }));
    return _updateUser.apply(this, arguments);
  }
  $("#form-edit-user").bootstrapValidator({
    fields: userFieldsValidationSchema,
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      updateUser();
      return false;
    }
  });
  function getResetPasswordFormValues() {
    var form = $("#form-reset-password");
    return {
      userId: form.find('input[name="userId"]').val(),
      userName: form.find('input[name="userName"]').val(),
      newPassword: form.find('input[name="newPassword"]').val(),
      confirmPassword: form.find('input[name="confirmPassword"]').val()
    };
  }
  function resetPassword() {
    return _resetPassword.apply(this, arguments);
  }
  function _resetPassword() {
    _resetPassword = _asyncToGenerator(_regeneratorRuntime().mark(function _callee8() {
      var formValues;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            formValues = getResetPasswordFormValues();
            _context8.next = 4;
            return _user["default"].updatePassword(formValues);
          case 4:
            _context8.next = 6;
            return Swal.fire({
              type: "success",
              text: errorMessage.message.update_user_success
            });
          case 6:
            $("#modal-reset-password").modal("hide");
            _context8.next = 12;
            break;
          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            Swal.fire({
              type: "error",
              text: _context8.t0.message
            });
          case 12:
            _context8.prev = 12;
            $("button[type=submit]").removeAttr("disabled");
            return _context8.finish(12);
          case 15:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[0, 9, 12, 15]]);
    }));
    return _resetPassword.apply(this, arguments);
  }
  $("#form-reset-password").bootstrapValidator({
    fields: {
      newPassword: {
        validators: {
          notEmpty: {
            message: errorMessage.error.validate_password_required
          },
          stringLength: {
            min: 6,
            max: 50,
            message: errorMessage.error.validate_password_minimum
          }
        }
      },
      confirmPassword: {
        validators: {
          notEmpty: {
            message: errorMessage.error.validate_confirmPassword_matched
          },
          identical: {
            field: "newPassword",
            message: errorMessage.error.validate_confirmPassword_matched
          }
        }
      }
    },
    onSuccess: function onSuccess(e) {
      e.preventDefault();
      resetPassword();
      return false;
    }
  });
  this.on("change", 'input[name="userType"]', function () {
    var formEl = $(this).closest("form");
    switch ($(this).val()) {
      case _constant.UserRole.SUPER_ADMIN:
        formEl.find(".form-group-organization").hide();
        formEl.find(".form-group-group").hide();
        $("#form-create-user").bootstrapValidator('revalidateField', 'organizationIds');
        break;
      case _constant.UserRole.ORG_ADMIN:
      case _constant.UserRole.ORG_SUPERVISOR:
        formEl.find(".form-group-organization").show();
        formEl.find(".form-group-group").hide();
        break;
      case _constant.UserRole.ORG_USER:
        if (currentRole === _constant.UserRole.ORG_ADMIN) {
          formEl.find(".form-group-organization").hide();
        } else {
          formEl.find(".form-group-organization").show();
        }
        formEl.find(".form-group-group").show();
        break;
    }
  });
  if (currentRole === _constant.UserRole.ORG_ADMIN) {
    this.find("input[value=\"".concat(_constant.UserRole.SUPER_ADMIN, "\"], input[value=\"").concat(_constant.UserRole.ORG_ADMIN, "\"]")).parents(".radio").remove();
  }
  this.find("select[name='groupIds']").select2();
  var organizationSelects = this.find("select[name='organizationIds']").select2({
    placeholder: "Select Organization"
  }).on("change", function () {
    var groupSelect = $(this).closest("form").find("select[name='groupIds']");
    var organizationId = parseInt($(this).val(), 10);
    if (!organizationId) {
      groupSelect.empty().change();
    } else {
      _group["default"].listByOrganization(organizationId).then(function (_ref6) {
        var data = _ref6.data;
        groupSelect.options(data, ["id", "groupName"]).each(function () {
          $(this).val($(this).data("futureValue"));
        });
      });
    }
  });
  _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var organizationList;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!userOrgId) {
            _context2.next = 4;
            break;
          }
          _context2.t0 = [{
            label: userOrgName,
            value: userOrgId
          }];
          _context2.next = 10;
          break;
        case 4:
          _context2.t1 = _;
          _context2.next = 7;
          return _organization["default"].list();
        case 7:
          _context2.t2 = _context2.sent;
          _context2.t3 = [];
          _context2.t0 = _context2.t1.get.call(_context2.t1, _context2.t2, "data.data", _context2.t3).map(function (_ref8) {
            var value = _ref8.organizationId,
              label = _ref8.organizationName;
            return {
              label: label,
              value: value
            };
          });
        case 10:
          organizationList = _context2.t0;
          organizationSelects.options(organizationList).change();
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))();
  this.find("#modal-create-user, #modal-edit-user").on("hidden.bs.modal", function () {
    $(this).find("form").clearForm().find("select").change();
  }).filter(function () {
    return this.id.includes("create");
  }).on("show.bs.modal", function () {
    var modalEl = $(this);
    modalEl.find("input[name='userType']").first().prop("checked", true).change();
    if (userOrgId) {
      modalEl.find("select[name='organizationIds']").val(userOrgId).change();
    }
  });
  this.find("#modal-reset-password").on("hidden.bs.modal", function () {
    $(this).find("form").clearForm();
  });
  this.on("click", ".btn-edit-user", function () {
    var _ref9 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(event) {
      var dropdownBtn, userId, _yield$userApi$get, data, email, userName, firstName, lastName, defaultPSAPID, userRoles, additionalInfo, roleName, _ref10, organizations, groups, organizationId, groupIds, modalEl;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            event.preventDefault();
            dropdownBtn = $(this).closest("ul").prev().loading(true);
            _context3.prev = 2;
            userId = $(this).closest("tr").attr("id");
            _context3.next = 6;
            return _user["default"].get(userId);
          case 6:
            _yield$userApi$get = _context3.sent;
            data = _yield$userApi$get.data;
            email = data.email, userName = data.userName, firstName = data.firstName, lastName = data.lastName, defaultPSAPID = data.defaultPSAPID, userRoles = data.userRoles, additionalInfo = data.additionalInfo;
            roleName = _.get(userRoles, "roleName");
            _ref10 = additionalInfo || {}, organizations = _ref10.organizations, groups = _ref10.groups;
            organizationId = _.get(organizations, "organizationId");
            groupIds = (groups || []).map(function (g) {
              return g.groupId;
            });
            modalEl = $("#modal-edit-user");
            modalEl.find('input[name="userType"]').prop("disabled", true);
            modalEl.find('input[name="id"]').val(userId);
            modalEl.find('input[name="userType"]').filter("[value=".concat(roleName, "]")).prop("checked", true).change();
            modalEl.find('input[name="email"]').val(email);
            modalEl.find('input[name="userName"]').val(userName);
            modalEl.find('input[name="firstName"]').val(firstName);
            modalEl.find('input[name="lastName"]').val(lastName);
            modalEl.find('input[name="defaultPSAPID"]').val(defaultPSAPID || "SNO911");
            modalEl.find('select[name="organizationIds"]').val(organizationId).change();
            modalEl.find("select[name=groupIds]").data("futureValue", groupIds);
            modalEl.modal("show");
            _context3.next = 30;
            break;
          case 27:
            _context3.prev = 27;
            _context3.t0 = _context3["catch"](2);
            Swal.fire({
              type: "error",
              text: _context3.t0.message
            });
          case 30:
            _context3.prev = 30;
            dropdownBtn.loading(false);
            return _context3.finish(30);
          case 33:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this, [[2, 27, 30, 33]]);
    }));
    return function (_x3) {
      return _ref9.apply(this, arguments);
    };
  }());
  this.on("click", ".btn-delete-user", function () {
    var _ref11 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(event) {
      var dropdownBtn, result, userId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            event.preventDefault();
            dropdownBtn = $(this).closest("ul").prev();
            _context4.prev = 2;
            _context4.next = 5;
            return Swal.fire({
              title: errorMessage.message.confirm_delete_user,
              text: "You won't be able to revert this!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, delete it!"
            });
          case 5:
            result = _context4.sent;
            if (result.value) {
              _context4.next = 8;
              break;
            }
            return _context4.abrupt("return");
          case 8:
            dropdownBtn.loading(true);
            userId = $(this).closest("tr").attr("id");
            _context4.next = 12;
            return _user["default"].remove(userId);
          case 12:
            table.ajax.reload(null, false);
            _context4.next = 15;
            return Swal.fire("Deleted!", errorMessage.message.delete_user_success, "success");
          case 15:
            _context4.next = 20;
            break;
          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](2);
            if (_context4.t0.status === 400 && _context4.t0.message.includes("foreign key constraint fails")) {
              Swal.fire({
                type: "error",
                text: 'We can’t delete this user because this user has CFSes'
              });
            } else {
              Swal.fire({
                type: "error",
                text: _context4.t0.message
              });
            }
          case 20:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[2, 17]]);
    }));
    return function (_x4) {
      return _ref11.apply(this, arguments);
    };
  }());
  this.on("click", ".btn-reset-password", function (event) {
    event.preventDefault();
    var modalEl = $("#modal-reset-password");
    var row = table.row($(this).closest("tr"));
    var _row$data = row.data(),
      id = _row$data.id,
      userName = _row$data.userName;
    modalEl.find('input[name="userId"]').val(id);
    modalEl.find('input[name="userName"]').val(userName);
    modalEl.modal("show");
  });
  this.on("click", ".btn-un-pin", function () {
    var _ref12 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5(event) {
      var row, _row$data2, id, requestData;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            event.preventDefault();
            row = table.row($(this).closest("tr"));
            _row$data2 = row.data(), id = _row$data2.id;
            requestData = {
              userId: id
            };
            _context5.prev = 4;
            _context5.next = 7;
            return _organization["default"].authenticateUnPin(requestData);
          case 7:
            _context5.next = 9;
            return Swal.fire("Unlock User!", errorMessage.message.unpin_user_success, "success");
          case 9:
            _context5.next = 14;
            break;
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](4);
            Swal.fire({
              type: "error",
              text: _context5.t0.message
            });
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this, [[4, 11]]);
    }));
    return function (_x5) {
      return _ref12.apply(this, arguments);
    };
  }());
}

},{"../../../common/constant":4,"../../../models/userProfile":17,"../../../services/api/group":39,"../../../services/api/organization":42,"../../../services/api/user":47}],26:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
var _navigator = _interopRequireDefault(require("../../router/navigator"));
var _organization = _interopRequireDefault(require("../../services/api/organization"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var isModal,
      _global$organization,
      isRequiredPinAllUser,
      pinLength,
      pinCountFailed,
      latestSetPinFailedAt,
      checkAttempt,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          isModal = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
          _global$organization = global.organization, isRequiredPinAllUser = _global$organization.isRequiredPinAllUser, pinLength = _global$organization.pinLength;
          if (!isModal) {
            !isRequiredPinAllUser || isRequiredPinAllUser && localStorage.getItem("pin") && localStorage.getItem("verifyPin") && _navigator["default"].reset();
            $("#new-cfs-btn").parent().remove();
            $("#resources-dropdown").remove();
            $("#main-menu").parent().remove();
            $(".last-update-section").remove();
            $("#admin-dashboard-menu").remove();
            this.promise().done(function () {
              $(".splash-screen").fadeOut("show");
            });
          }
          pinCountFailed = _userProfile["default"].pinCountFailed, latestSetPinFailedAt = _userProfile["default"].latestSetPinFailedAt;
          checkAttempt = function checkAttempt(pinCountFailed, latestSetPinFailedAt) {
            if (latestSetPinFailedAt && pinCountFailed > 0) {
              var now = moment.utc().format("MM/DD/YYYY HH:mm:ss");
              var then = global.Utils.convertFromUtc(latestSetPinFailedAt);
              var lastFailTimeInMinutes = moment.duration(moment(now, "MM/DD/YYYY HH:mm:ss").diff(moment(then, "MM/DD/YYYY HH:mm:ss"))).asMinutes();
              $(".check-pin").find(".count-attempt-left-number").text(global.ATTEMPT_TIME_INPUT_WRONG_PIN - pinCountFailed >= 0 ? global.ATTEMPT_TIME_INPUT_WRONG_PIN - pinCountFailed : 0);
              if (lastFailTimeInMinutes < global.WAITING_TIME_TRY_INPUT_PIN_AGAIN_IN_MINUTES && pinCountFailed >= global.ATTEMPT_TIME_INPUT_WRONG_PIN) {
                $(".check-pin").find(".count-attempt-left").show();
                $(".check-pin").addClass("show-error");
                $(".check-pin").find(".time-attempt-next").text(global.WAITING_TIME_TRY_INPUT_PIN_AGAIN_IN_MINUTES - Math.floor(lastFailTimeInMinutes));
              } else if (pinCountFailed < global.ATTEMPT_TIME_INPUT_WRONG_PIN && pinCountFailed > 0) {
                $(".check-pin").find(".count-attempt-left").show();
              }
            }
          };
          checkAttempt(pinCountFailed, latestSetPinFailedAt);
          $("input[name='pin']").each(function (index, item) {
            if (index >= pinLength) $(item).parent().remove();
          });
          $("input[name='pin']").on("keyup", function (e) {
            if (e.which === 8) {
              $(this).parent().prev().find("input[name='pin']").focus();
            }
          });
          $("input[name='pin']").on("keypress", function (e) {
            var _this = this;
            if ((e.which < 48 || e.which > 57) && e.which !== 13) {
              e.preventDefault();
            } else {
              if (e.which !== 13) {
                setTimeout(function () {
                  $(_this).val(e.key);
                  $(_this).parent().next().find("input[name='pin']").focus();
                });
              }
            }
          });
          $(".submit-btn").on("click", function () {
            var _ref2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(e) {
              var pin, requestData;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    e.preventDefault();
                    pin = "";
                    $("input[name='pin']").each(function (index, element) {
                      pin += $(element).val().trim();
                    });
                    _context.prev = 3;
                    requestData = {
                      organizationId: _userProfile["default"].organizationId,
                      pin: pin
                    };
                    _context.next = 7;
                    return _organization["default"].authenticatePin(requestData);
                  case 7:
                    localStorage.setItem("pin", pin);
                    if (isModal) {
                      $('#modal-checkpin').modal('hide');
                      $("#modal-checkpin").find(".count-attempt-left").hide();
                      $("#modal-checkpin form")[0].reset();
                      pinCountFailed = 0;
                    } else {
                      _navigator["default"].reset();
                    }
                    _context.next = 17;
                    break;
                  case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](3);
                    Swal.fire({
                      type: "error",
                      title: "PIN is incorrect"
                    });
                    pinCountFailed++;
                    latestSetPinFailedAt = moment.utc().format();
                    checkAttempt(pinCountFailed, latestSetPinFailedAt);
                  case 17:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[3, 11]]);
            }));
            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }());
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this);
  }));
  return _ref.apply(this, arguments);
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../models/userProfile":17,"../../router/navigator":30,"../../services/api/organization":42}],27:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
function _default() {
  global.dashboardInit();
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],28:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _auth = _interopRequireDefault(require("../../services/auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _default() {
  this.promise().done(function () {
    $(".splash-screen").fadeOut("show");
  });
  $("#login-form").on("submit", function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(event) {
      var form, username, password;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            form = $(this);
            form.find("#btn-login").button("loading");
            _context.prev = 3;
            username = form.find("#login-username").val().toLowerCase();
            password = form.find("#login-password").val();
            _context.next = 8;
            return _auth["default"].signIn({
              username: username,
              password: password
            });
          case 8:
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            Swal.fire({
              type: "error",
              text: _context.t0.message
            });
          case 13:
            _context.prev = 13;
            form.find("#btn-login").button("reset");
            return _context.finish(13);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[3, 10, 13, 16]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}

},{"../../services/auth":48}],29:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.router = router;
var _constant = require("../common/constant");
var _admin = _interopRequireDefault(require("../components/layout/admin"));
var _user = _interopRequireDefault(require("../components/layout/user"));
var _empty = _interopRequireDefault(require("../components/layout/empty"));
var _userProfile = _interopRequireDefault(require("../models/userProfile"));
var _configuration = _interopRequireDefault(require("../pages/admin/configuration"));
var _createLinksFiles = _interopRequireDefault(require("../pages/admin/createLinksFiles"));
var _group = _interopRequireDefault(require("../pages/admin/group"));
var _messageHistory = _interopRequireDefault(require("../pages/admin/messageHistory"));
var _organization = _interopRequireDefault(require("../pages/admin/organization"));
var _organizationSettings = _interopRequireDefault(require("../pages/admin/organizationSettings"));
var _uploadFiles = _interopRequireDefault(require("../pages/admin/uploadFiles"));
var _user2 = _interopRequireDefault(require("../pages/admin/user"));
var _dashboard = _interopRequireDefault(require("../pages/dashboard"));
var _login = _interopRequireDefault(require("../pages/login"));
var _auth = _interopRequireDefault(require("../services/auth"));
var _navigator = _interopRequireDefault(require("./navigator"));
var _checkPin = _interopRequireDefault(require("../pages/checkPin"));
var _organization2 = _interopRequireDefault(require("../services/api/organization"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Route = function () {
  function Route(_ref) {
    var path = _ref.path,
      render = _ref.render,
      allow = _ref.allow;
    _classCallCheck(this, Route);
    this.path = path;
    this.render = render;
    this.allow = allow;
  }
  return _createClass(Route, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
        var _yield$this$render, _yield$this$render2, htmlPath, onComplete;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.render();
            case 3:
              _yield$this$render = _context.sent;
              _yield$this$render2 = _slicedToArray(_yield$this$render, 2);
              htmlPath = _yield$this$render2[0];
              onComplete = _yield$this$render2[1];
              $.get(htmlPath, function (htmlData) {
                var $app = $("#app").html(htmlData);
                onComplete.call($app);
              });
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              alert("Error in render phase: " + _context.t0.message);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }]);
}();
var Redirect = _createClass(function Redirect(_ref2) {
  var path = _ref2.path,
    to = _ref2.to;
  _classCallCheck(this, Redirect);
  this.path = path;
  this.to = to;
});
var switches = [new Redirect({
  path: "/",
  to: function to(_ref3) {
    var role = _ref3.role;
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _constant.UserRole.SUPER_ADMIN, "/admin-dashboard"), _constant.UserRole.ORG_ADMIN, "/admin-dashboard"), _constant.UserRole.ORG_SUPERVISOR, "/admin-dashboard"), _constant.UserRole.ORG_USER, "/dashboard")[role] || "/login";
  }
}), new Redirect({
  path: "/admin-dashboard",
  to: function to(_ref4) {
    var role = _ref4.role;
    return _defineProperty(_defineProperty(_defineProperty({}, _constant.UserRole.SUPER_ADMIN, "/organization"), _constant.UserRole.ORG_ADMIN, "/organization-settings"), _constant.UserRole.ORG_SUPERVISOR, "/organization-settings")[role] || "/login";
  }
}), new Route({
  path: "/login",
  render: function render() {
    return ["/login.html", _login["default"]];
  }
}), new Route({
  path: "/user",
  allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN, _constant.UserRole.ORG_SUPERVISOR],
  render: function render() {
    return (0, _admin["default"])("/Administrator/user.html", _user2["default"]);
  }
}), new Route({
  path: "/group",
  allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN],
  render: function render() {
    return (0, _admin["default"])("/Administrator/group.html", _group["default"]);
  }
}), new Route({
  path: "/create-links-files",
  allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN],
  render: function render() {
    return (0, _admin["default"])("/Administrator/createLinksFiles.html", _createLinksFiles["default"]);
  }
}), new Route({
  path: "/upload-files",
  allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN],
  render: function render() {
    return (0, _admin["default"])("/Administrator/uploadFiles.html", _uploadFiles["default"]);
  }
}), new Route({
  path: "/message-history",
  allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN, _constant.UserRole.ORG_SUPERVISOR],
  render: function render() {
    return (0, _admin["default"])("/Administrator/messageHistory.html", _messageHistory["default"]);
  }
}), new Route({
  path: "/organization",
  allow: [_constant.UserRole.SUPER_ADMIN],
  render: function render() {
    return (0, _admin["default"])("/Administrator/organization.html", _organization["default"]);
  }
}), new Route({
  path: "/configuration",
  allow: [_constant.UserRole.SUPER_ADMIN, _constant.UserRole.ORG_ADMIN],
  render: function render() {
    return (0, _admin["default"])("/Administrator/configuration.html", _configuration["default"]);
  }
}), new Route({
  path: "/organization-settings",
  allow: [_constant.UserRole, _constant.UserRole.ORG_ADMIN, _constant.UserRole.ORG_SUPERVISOR],
  render: function render() {
    return (0, _admin["default"])("/Administrator/organizationSettings.html", _organizationSettings["default"]);
  }
}), new Route({
  path: "/dashboard",
  allow: [_constant.UserRole.ORG_ADMIN, _constant.UserRole.ORG_SUPERVISOR, _constant.UserRole.ORG_USER],
  render: function render() {
    return (0, _user["default"])("/MasterView/dashboard.html", _dashboard["default"]);
  }
}), new Route({
  path: "/check-pin",
  allow: [_constant.UserRole.ORG_ADMIN, _constant.UserRole.ORG_SUPERVISOR, _constant.UserRole.ORG_USER],
  render: function render() {
    return (0, _empty["default"])("/MasterView/checkPin.html", _checkPin["default"]);
  }
})];
function router() {
  return _router.apply(this, arguments);
}
function _router() {
  _router = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var pathname, role, isRequiredPinAllUser, verifyPin, _yield$userProfile$re, roleName, organizationId, _yield$organizationAp, data, requestData, matchedRoute, checkAccessPin;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          pathname = window.location.pathname;
          _context2.next = 3;
          return _auth["default"].refreshSession();
        case 3:
          if (!_auth["default"].isSignedIn) {
            _context2.next = 31;
            break;
          }
          _context2.next = 6;
          return _userProfile["default"].refresh();
        case 6:
          _yield$userProfile$re = _context2.sent;
          roleName = _yield$userProfile$re.roleName;
          organizationId = _userProfile["default"].organizationId;
          if (!(roleName !== _constant.UserRole.SUPER_ADMIN)) {
            _context2.next = 30;
            break;
          }
          _context2.next = 12;
          return _organization2["default"].get(organizationId);
        case 12:
          _yield$organizationAp = _context2.sent;
          data = _yield$organizationAp.data;
          if (!localStorage.getItem("pin")) {
            _context2.next = 28;
            break;
          }
          _context2.prev = 15;
          requestData = {
            organizationId: _userProfile["default"].organizationId,
            pin: localStorage.getItem("pin")
          };
          _context2.next = 19;
          return _organization2["default"].authenticatePin(requestData);
        case 19:
          verifyPin = true;
          localStorage.setItem("verifyPin", true);
          _context2.next = 28;
          break;
        case 23:
          _context2.prev = 23;
          _context2.t0 = _context2["catch"](15);
          verifyPin = false;
          localStorage.setItem("verifyPin", false);
          localStorage.setItem("pin", "");
        case 28:
          global.organization = data;
          isRequiredPinAllUser = data.isRequiredPinAllUser;
        case 30:
          role = roleName;
        case 31:
          matchedRoute = switches.find(function (route) {
            return route.path === pathname && (!Array.isArray(route.allow) || route.allow.includes(role));
          });
          checkAccessPin = function checkAccessPin() {
            return role === _constant.UserRole.SUPER_ADMIN || pathname === "/check-pin" || !isRequiredPinAllUser || isRequiredPinAllUser && localStorage.getItem("pin") && verifyPin;
          };
          if (matchedRoute) {
            _context2.next = 37;
            break;
          }
          _navigator["default"].reset();
          _context2.next = 41;
          break;
        case 37:
          if (checkAccessPin()) {
            _context2.next = 40;
            break;
          }
          _navigator["default"].to("check-pin");
          return _context2.abrupt("return");
        case 40:
          if (matchedRoute instanceof Redirect) {
            _navigator["default"].to(matchedRoute.to({
              role: role
            }));
          } else {
            matchedRoute.load();
          }
        case 41:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[15, 23]]);
  }));
  return _router.apply(this, arguments);
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../common/constant":4,"../components/layout/admin":12,"../components/layout/empty":13,"../components/layout/user":14,"../models/userProfile":17,"../pages/admin/configuration":18,"../pages/admin/createLinksFiles":19,"../pages/admin/group":20,"../pages/admin/messageHistory":21,"../pages/admin/organization":22,"../pages/admin/organizationSettings":23,"../pages/admin/uploadFiles":24,"../pages/admin/user":25,"../pages/checkPin":26,"../pages/dashboard":27,"../pages/login":28,"../services/api/organization":42,"../services/auth":48,"./navigator":30}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function to(pathname) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var currentPath = window.location.pathname;
  if (currentPath !== pathname || force) {
    localStorage.setItem('refresh', 1);
    window.location.href = pathname;
  }
}
function reset() {
  to("/");
}
var _default = exports["default"] = {
  to: to,
  reset: reset
};

},{}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("./httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var endpoint = "".concat(window.ENV.AUDIT_LOG_ENDPOINT, "/api/api-logs");
function list(_x) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(_ref) {
    var startDate, endDate;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          startDate = _ref.startDate, endDate = _ref.endDate;
          return _context.abrupt("return", _httpClient["default"].get("".concat(endpoint), {
            params: {
              startDate: startDate,
              endDate: endDate
            }
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
var _default = exports["default"] = {
  list: list
};

},{"./httpClient":40}],32:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _compatibilityHelpers = require("../../common/compatibilityHelpers");
var _httpClient = _interopRequireDefault(require("./httpClient"));
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var endpoint = "".concat(window.ENV.CFS_ENDPOINT, "/api/cfs");
function list(_x) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(params) {
    var _response$data$cfsDat;
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _httpClient["default"].get("".concat(endpoint, "/get-paging"), {
            params: params
          });
        case 2:
          response = _context.sent;
          (_response$data$cfsDat = response.data.cfsDatas) === null || _response$data$cfsDat === void 0 || _response$data$cfsDat.forEach(function (element) {
            var _element$unitsAssigne;
            global.migrateDataKeyMapWithOldVersion(element);
            (_element$unitsAssigne = element.unitsAssigned) === null || _element$unitsAssigne === void 0 || _element$unitsAssigne.forEach(function (unit) {
              return global.migrateDataKeyMapWithOldVersion(unit);
            });
          });
          return _context.abrupt("return", response);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
function updateEcc(cfsData) {
  return _httpClient["default"].put("".concat(endpoint, "/update-ecc"), cfsData);
}
function create() {
  return _create.apply(this, arguments);
}
function _create() {
  _create = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _httpClient["default"].post("".concat(endpoint, "/create"));
        case 2:
          response = _context2.sent;
          (0, _compatibilityHelpers.remapField)(response.data, {
            cfsid: "cfsId",
            incidentID: "incidentId"
          });
          return _context2.abrupt("return", response);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}
function update(_x2) {
  return _update.apply(this, arguments);
}
function _update() {
  _update = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(cfsData) {
    var response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (cfsData.fireCallType === '') cfsData.fireCallType = null;
          if (cfsData.policeCallType === '') cfsData.policeCallType = null;
          _context3.next = 4;
          return _httpClient["default"].put("".concat(endpoint, "/update"), cfsData);
        case 4:
          response = _context3.sent;
          (0, _compatibilityHelpers.remapField)(response.data, {
            cfsid: "cfsId",
            incidentID: "incidentId"
          });
          return _context3.abrupt("return", response);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _update.apply(this, arguments);
}
function getReport(params) {
  return _httpClient["default"].get("".concat(endpoint, "/get-report-details-date-range"), {
    params: params
  });
}
function listAssignedUnits(incidentId) {
  return _httpClient["default"].get("".concat(endpoint, "/get-unit-assigned"), {
    params: {
      incidentId: incidentId
    }
  });
}
function listCfsLogs(_x3) {
  return _listCfsLogs.apply(this, arguments);
}
function _listCfsLogs() {
  _listCfsLogs = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(params) {
    var responseData;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return _httpClient["default"].get("".concat(endpoint, "/get-log-cfs"), {
            params: params
          });
        case 2:
          responseData = _context4.sent;
          _.forEach(responseData.data, function (logRecord) {
            return global.migrateDataKeyMapWithOldVersion(logRecord);
          });
          if (!Array.isArray(responseData.data)) responseData.data = [];
          return _context4.abrupt("return", responseData);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _listCfsLogs.apply(this, arguments);
}
function getCfsDetail(_x4) {
  return _getCfsDetail.apply(this, arguments);
}
function _getCfsDetail() {
  _getCfsDetail = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5(params) {
    var incidentId, cfsOrUnitId, response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          incidentId = params.incidentId, cfsOrUnitId = params.cfsOrUnitId;
          if (!incidentId) {
            _context5.next = 7;
            break;
          }
          _context5.next = 4;
          return _httpClient["default"].get("".concat(endpoint, "/").concat(incidentId, "/detail"));
        case 4:
          response = _context5.sent;
          _context5.next = 10;
          break;
        case 7:
          _context5.next = 9;
          return _httpClient["default"].get("".concat(endpoint, "/get-display-call"), {
            params: {
              displayStr: cfsOrUnitId
            }
          });
        case 9:
          response = _context5.sent;
        case 10:
          (0, _compatibilityHelpers.remapField)(response.data, {
            cfsid: "cfsId",
            incidentID: "incidentId"
          });
          return _context5.abrupt("return", response);
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getCfsDetail.apply(this, arguments);
}
function getLatestLog(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/get-latest-log-cfs"), {
    params: {
      organizationId: organizationId
    }
  });
}
function migrate(request) {
  return _httpClient["default"].post("".concat(endpoint, "/migrate-call"), request);
}
function cancelCall(request) {
  return _httpClient["default"].post("".concat(endpoint, "/cancel-call"), request);
}
function getAllCfsOpening() {
  return _httpClient["default"].get("".concat(endpoint, "/get-all-opening"), {
    params: {
      organizationId: _userProfile["default"].organizationId
    }
  });
}
function reopenCall(incidentId) {
  return _httpClient["default"].post("".concat(endpoint, "/reopen-call"), {
    incidentId: incidentId
  });
}
function getRapidToken(_x5) {
  return _getRapidToken.apply(this, arguments);
}
function _getRapidToken() {
  _getRapidToken = _asyncToGenerator(_regeneratorRuntime().mark(function _callee6(rpNumber) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", _httpClient["default"].get("".concat(endpoint, "/get-rapid-irp"), {
            params: {
              rpNumber: rpNumber
            }
          }));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getRapidToken.apply(this, arguments);
}
var _default = exports["default"] = {
  create: create,
  update: update,
  list: list,
  getReport: getReport,
  listAssignedUnits: listAssignedUnits,
  listCfsLogs: listCfsLogs,
  getCfsDetail: getCfsDetail,
  getLatestLog: getLatestLog,
  migrate: migrate,
  cancelCall: cancelCall,
  getAllCfsOpening: getAllCfsOpening,
  reopenCall: reopenCall,
  updateEcc: updateEcc,
  getRapidToken: getRapidToken
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../common/compatibilityHelpers":3,"../../models/userProfile":17,"./httpClient":40}],33:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("./httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var endpoint = "".concat(window.ENV.CLI_ENDPOINT, "/api/cli");
function list() {
  var organizationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  organizationId = organizationId || global.userProfile.organizationId;
  return _httpClient["default"].get("".concat(endpoint, "/list?organizationId=").concat(organizationId));
}
function execute(params) {
  return _httpClient["default"].post("".concat(endpoint, "/command"), params);
}
var _default = exports["default"] = {
  list: list,
  execute: execute
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./httpClient":40}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function getTimeZones() {
  return _getTimeZones.apply(this, arguments);
}
function _getTimeZones() {
  _getTimeZones = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            data: dataTimeZone
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getTimeZones.apply(this, arguments);
}
var timeZoneOld = [{
  id: "Dateline Standard Time",
  displayName: "(UTC-12:00) International Date Line West",
  daylightName: "Dateline Daylight Time"
}, {
  id: "UTC-11",
  displayName: "(UTC-11:00) Coordinated Universal Time-11",
  daylightName: "UTC-11"
}, {
  id: "Aleutian Standard Time",
  displayName: "(UTC-10:00) Aleutian Islands",
  daylightName: "Aleutian Daylight Time"
}, {
  id: "Hawaiian Standard Time",
  displayName: "(UTC-10:00) Hawaii",
  daylightName: "Hawaiian Daylight Time"
}, {
  id: "Marquesas Standard Time",
  displayName: "(UTC-09:30) Marquesas Islands",
  daylightName: "Marquesas Daylight Time"
}, {
  id: "Alaskan Standard Time",
  displayName: "(UTC-09:00) Alaska",
  daylightName: "Alaskan Daylight Time"
}, {
  id: "UTC-09",
  displayName: "(UTC-09:00) Coordinated Universal Time-09",
  daylightName: "UTC-09"
}, {
  id: "Pacific Standard Time (Mexico)",
  displayName: "(UTC-08:00) Baja California",
  daylightName: "Pacific Daylight Time (Mexico)"
}, {
  id: "UTC-08",
  displayName: "(UTC-08:00) Coordinated Universal Time-08",
  daylightName: "UTC-08"
}, {
  id: "Pacific Standard Time",
  displayName: "(UTC-08:00) Pacific Time (US & Canada)",
  daylightName: "Pacific Daylight Time"
}, {
  id: "US Mountain Standard Time",
  displayName: "(UTC-07:00) Arizona",
  daylightName: "US Mountain Daylight Time"
}, {
  id: "Mountain Standard Time (Mexico)",
  displayName: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  daylightName: "Mountain Daylight Time (Mexico)"
}, {
  id: "Mountain Standard Time",
  displayName: "(UTC-07:00) Mountain Time (US & Canada)",
  daylightName: "Mountain Daylight Time"
}, {
  id: "Central America Standard Time",
  displayName: "(UTC-06:00) Central America",
  daylightName: "Central America Daylight Time"
}, {
  id: "Central Standard Time",
  displayName: "(UTC-06:00) Central Time (US & Canada)",
  daylightName: "Central Daylight Time"
}, {
  id: "Easter Island Standard Time",
  displayName: "(UTC-06:00) Easter Island",
  daylightName: "Easter Island Daylight Time"
}, {
  id: "Central Standard Time (Mexico)",
  displayName: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  daylightName: "Central Daylight Time (Mexico)"
}, {
  id: "Canada Central Standard Time",
  displayName: "(UTC-06:00) Saskatchewan",
  daylightName: "Canada Central Daylight Time"
}, {
  id: "SA Pacific Standard Time",
  displayName: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
  daylightName: "SA Pacific Daylight Time"
}, {
  id: "Eastern Standard Time (Mexico)",
  displayName: "(UTC-05:00) Chetumal",
  daylightName: "Eastern Daylight Time (Mexico)"
}, {
  id: "Eastern Standard Time",
  displayName: "(UTC-05:00) Eastern Time (US & Canada)",
  daylightName: "Eastern Daylight Time"
}, {
  id: "Haiti Standard Time",
  displayName: "(UTC-05:00) Haiti",
  daylightName: "Haiti Daylight Time"
}, {
  id: "Cuba Standard Time",
  displayName: "(UTC-05:00) Havana",
  daylightName: "Cuba Daylight Time"
}, {
  id: "US Eastern Standard Time",
  displayName: "(UTC-05:00) Indiana (East)",
  daylightName: "US Eastern Daylight Time"
}, {
  id: "Turks And Caicos Standard Time",
  displayName: "(UTC-05:00) Turks and Caicos",
  daylightName: "Turks and Caicos Daylight Time"
}, {
  id: "Paraguay Standard Time",
  displayName: "(UTC-04:00) Asuncion",
  daylightName: "Paraguay Daylight Time"
}, {
  id: "Atlantic Standard Time",
  displayName: "(UTC-04:00) Atlantic Time (Canada)",
  daylightName: "Atlantic Daylight Time"
}, {
  id: "Venezuela Standard Time",
  displayName: "(UTC-04:00) Caracas",
  daylightName: "Venezuela Daylight Time"
}, {
  id: "Central Brazilian Standard Time",
  displayName: "(UTC-04:00) Cuiaba",
  daylightName: "Central Brazilian Daylight Time"
}, {
  id: "SA Western Standard Time",
  displayName: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  daylightName: "SA Western Daylight Time"
}, {
  id: "Pacific SA Standard Time",
  displayName: "(UTC-04:00) Santiago",
  daylightName: "Pacific SA Daylight Time"
}, {
  id: "Newfoundland Standard Time",
  displayName: "(UTC-03:30) Newfoundland",
  daylightName: "Newfoundland Daylight Time"
}, {
  id: "Tocantins Standard Time",
  displayName: "(UTC-03:00) Araguaina",
  daylightName: "Tocantins Daylight Time"
}, {
  id: "E. South America Standard Time",
  displayName: "(UTC-03:00) Brasilia",
  daylightName: "E. South America Daylight Time"
}, {
  id: "SA Eastern Standard Time",
  displayName: "(UTC-03:00) Cayenne, Fortaleza",
  daylightName: "SA Eastern Daylight Time"
}, {
  id: "Argentina Standard Time",
  displayName: "(UTC-03:00) City of Buenos Aires",
  daylightName: "Argentina Daylight Time"
}, {
  id: "Greenland Standard Time",
  displayName: "(UTC-03:00) Greenland",
  daylightName: "Greenland Daylight Time"
}, {
  id: "Montevideo Standard Time",
  displayName: "(UTC-03:00) Montevideo",
  daylightName: "Montevideo Daylight Time"
}, {
  id: "Magallanes Standard Time",
  displayName: "(UTC-03:00) Punta Arenas",
  daylightName: "Magallanes Daylight Time"
}, {
  id: "Saint Pierre Standard Time",
  displayName: "(UTC-03:00) Saint Pierre and Miquelon",
  daylightName: "Saint Pierre Daylight Time"
}, {
  id: "Bahia Standard Time",
  displayName: "(UTC-03:00) Salvador",
  daylightName: "Bahia Daylight Time"
}, {
  id: "UTC-02",
  displayName: "(UTC-02:00) Coordinated Universal Time-02",
  daylightName: "UTC-02"
}, {
  id: "Mid-Atlantic Standard Time",
  displayName: "(UTC-02:00) Mid-Atlantic - Old",
  daylightName: "Mid-Atlantic Daylight Time"
}, {
  id: "Azores Standard Time",
  displayName: "(UTC-01:00) Azores",
  daylightName: "Azores Daylight Time"
}, {
  id: "Cape Verde Standard Time",
  displayName: "(UTC-01:00) Cabo Verde Is.",
  daylightName: "Cabo Verde Daylight Time"
}, {
  id: "UTC",
  displayName: "(UTC) Coordinated Universal Time",
  daylightName: "Coordinated Universal Time"
}, {
  id: "Morocco Standard Time",
  displayName: "(UTC+00:00) Casablanca",
  daylightName: "Morocco Daylight Time"
}, {
  id: "GMT Standard Time",
  displayName: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
  daylightName: "GMT Daylight Time"
}, {
  id: "Greenwich Standard Time",
  displayName: "(UTC+00:00) Monrovia, Reykjavik",
  daylightName: "Greenwich Daylight Time"
}, {
  id: "W. Europe Standard Time",
  displayName: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  daylightName: "W. Europe Daylight Time"
}, {
  id: "Central Europe Standard Time",
  displayName: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  daylightName: "Central Europe Daylight Time"
}, {
  id: "Romance Standard Time",
  displayName: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  daylightName: "Romance Daylight Time"
}, {
  id: "Sao Tome Standard Time",
  displayName: "(UTC+01:00) Sao Tome",
  daylightName: "Sao Tome Daylight Time"
}, {
  id: "Central European Standard Time",
  displayName: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  daylightName: "Central European Daylight Time"
}, {
  id: "W. Central Africa Standard Time",
  displayName: "(UTC+01:00) West Central Africa",
  daylightName: "W. Central Africa Daylight Time"
}, {
  id: "Jordan Standard Time",
  displayName: "(UTC+02:00) Amman",
  daylightName: "Jordan Daylight Time"
}, {
  id: "GTB Standard Time",
  displayName: "(UTC+02:00) Athens, Bucharest",
  daylightName: "GTB Daylight Time"
}, {
  id: "Middle East Standard Time",
  displayName: "(UTC+02:00) Beirut",
  daylightName: "Middle East Daylight Time"
}, {
  id: "Egypt Standard Time",
  displayName: "(UTC+02:00) Cairo",
  daylightName: "Egypt Daylight Time"
}, {
  id: "E. Europe Standard Time",
  displayName: "(UTC+02:00) Chisinau",
  daylightName: "E. Europe Daylight Time"
}, {
  id: "Syria Standard Time",
  displayName: "(UTC+02:00) Damascus",
  daylightName: "Syria Daylight Time"
}, {
  id: "West Bank Standard Time",
  displayName: "(UTC+02:00) Gaza, Hebron",
  daylightName: "West Bank Gaza Daylight Time"
}, {
  id: "South Africa Standard Time",
  displayName: "(UTC+02:00) Harare, Pretoria",
  daylightName: "South Africa Daylight Time"
}, {
  id: "FLE Standard Time",
  displayName: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  daylightName: "FLE Daylight Time"
}, {
  id: "Israel Standard Time",
  displayName: "(UTC+02:00) Jerusalem",
  daylightName: "Jerusalem Daylight Time"
}, {
  id: "Kaliningrad Standard Time",
  displayName: "(UTC+02:00) Kaliningrad",
  daylightName: "Russia TZ 1 Daylight Time"
}, {
  id: "Sudan Standard Time",
  displayName: "(UTC+02:00) Khartoum",
  daylightName: "Sudan Daylight Time"
}, {
  id: "Libya Standard Time",
  displayName: "(UTC+02:00) Tripoli",
  daylightName: "Libya Daylight Time"
}, {
  id: "Namibia Standard Time",
  displayName: "(UTC+02:00) Windhoek",
  daylightName: "Namibia Daylight Time"
}, {
  id: "Arabic Standard Time",
  displayName: "(UTC+03:00) Baghdad",
  daylightName: "Arabic Daylight Time"
}, {
  id: "Turkey Standard Time",
  displayName: "(UTC+03:00) Istanbul",
  daylightName: "Turkey Daylight Time"
}, {
  id: "Arab Standard Time",
  displayName: "(UTC+03:00) Kuwait, Riyadh",
  daylightName: "Arab Daylight Time"
}, {
  id: "Belarus Standard Time",
  displayName: "(UTC+03:00) Minsk",
  daylightName: "Belarus Daylight Time"
}, {
  id: "Russian Standard Time",
  displayName: "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
  daylightName: "Russia TZ 2 Daylight Time"
}, {
  id: "E. Africa Standard Time",
  displayName: "(UTC+03:00) Nairobi",
  daylightName: "E. Africa Daylight Time"
}, {
  id: "Iran Standard Time",
  displayName: "(UTC+03:30) Tehran",
  daylightName: "Iran Daylight Time"
}, {
  id: "Arabian Standard Time",
  displayName: "(UTC+04:00) Abu Dhabi, Muscat",
  daylightName: "Arabian Daylight Time"
}, {
  id: "Astrakhan Standard Time",
  displayName: "(UTC+04:00) Astrakhan, Ulyanovsk",
  daylightName: "Astrakhan Daylight Time"
}, {
  id: "Azerbaijan Standard Time",
  displayName: "(UTC+04:00) Baku",
  daylightName: "Azerbaijan Daylight Time"
}, {
  id: "Russia Time Zone 3",
  displayName: "(UTC+04:00) Izhevsk, Samara",
  daylightName: "Russia TZ 3 Daylight Time"
}, {
  id: "Mauritius Standard Time",
  displayName: "(UTC+04:00) Port Louis",
  daylightName: "Mauritius Daylight Time"
}, {
  id: "Saratov Standard Time",
  displayName: "(UTC+04:00) Saratov",
  daylightName: "Saratov Daylight Time"
}, {
  id: "Georgian Standard Time",
  displayName: "(UTC+04:00) Tbilisi",
  daylightName: "Georgian Daylight Time"
}, {
  id: "Caucasus Standard Time",
  displayName: "(UTC+04:00) Yerevan",
  daylightName: "Caucasus Daylight Time"
}, {
  id: "Afghanistan Standard Time",
  displayName: "(UTC+04:30) Kabul",
  daylightName: "Afghanistan Daylight Time"
}, {
  id: "West Asia Standard Time",
  displayName: "(UTC+05:00) Ashgabat, Tashkent",
  daylightName: "West Asia Daylight Time"
}, {
  id: "Ekaterinburg Standard Time",
  displayName: "(UTC+05:00) Ekaterinburg",
  daylightName: "Russia TZ 4 Daylight Time"
}, {
  id: "Pakistan Standard Time",
  displayName: "(UTC+05:00) Islamabad, Karachi",
  daylightName: "Pakistan Daylight Time"
}, {
  id: "India Standard Time",
  displayName: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  daylightName: "India Daylight Time"
}, {
  id: "Sri Lanka Standard Time",
  displayName: "(UTC+05:30) Sri Jayawardenepura",
  daylightName: "Sri Lanka Daylight Time"
}, {
  id: "Nepal Standard Time",
  displayName: "(UTC+05:45) Kathmandu",
  daylightName: "Nepal Daylight Time"
}, {
  id: "Central Asia Standard Time",
  displayName: "(UTC+06:00) Astana",
  daylightName: "Central Asia Daylight Time"
}, {
  id: "Bangladesh Standard Time",
  displayName: "(UTC+06:00) Dhaka",
  daylightName: "Bangladesh Daylight Time"
}, {
  id: "Omsk Standard Time",
  displayName: "(UTC+06:00) Omsk",
  daylightName: "Omsk Daylight Time"
}, {
  id: "Myanmar Standard Time",
  displayName: "(UTC+06:30) Yangon (Rangoon)",
  daylightName: "Myanmar Daylight Time"
}, {
  id: "SE Asia Standard Time",
  displayName: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  daylightName: "SE Asia Daylight Time"
}, {
  id: "Altai Standard Time",
  displayName: "(UTC+07:00) Barnaul, Gorno-Altaysk",
  daylightName: "Altai Daylight Time"
}, {
  id: "W. Mongolia Standard Time",
  displayName: "(UTC+07:00) Hovd",
  daylightName: "W. Mongolia Daylight Time"
}, {
  id: "North Asia Standard Time",
  displayName: "(UTC+07:00) Krasnoyarsk",
  daylightName: "Russia TZ 6 Daylight Time"
}, {
  id: "N. Central Asia Standard Time",
  displayName: "(UTC+07:00) Novosibirsk",
  daylightName: "Novosibirsk Daylight Time"
}, {
  id: "Tomsk Standard Time",
  displayName: "(UTC+07:00) Tomsk",
  daylightName: "Tomsk Daylight Time"
}, {
  id: "China Standard Time",
  displayName: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  daylightName: "China Daylight Time"
}, {
  id: "North Asia East Standard Time",
  displayName: "(UTC+08:00) Irkutsk",
  daylightName: "Russia TZ 7 Daylight Time"
}, {
  id: "Singapore Standard Time",
  displayName: "(UTC+08:00) Kuala Lumpur, Singapore",
  daylightName: "Malay Peninsula Daylight Time"
}, {
  id: "W. Australia Standard Time",
  displayName: "(UTC+08:00) Perth",
  daylightName: "W. Australia Daylight Time"
}, {
  id: "Taipei Standard Time",
  displayName: "(UTC+08:00) Taipei",
  daylightName: "Taipei Daylight Time"
}, {
  id: "Ulaanbaatar Standard Time",
  displayName: "(UTC+08:00) Ulaanbaatar",
  daylightName: "Ulaanbaatar Daylight Time"
}, {
  id: "Aus Central W. Standard Time",
  displayName: "(UTC+08:45) Eucla",
  daylightName: "Aus Central W. Daylight Time"
}, {
  id: "Transbaikal Standard Time",
  displayName: "(UTC+09:00) Chita",
  daylightName: "Transbaikal Daylight Time"
}, {
  id: "Tokyo Standard Time",
  displayName: "(UTC+09:00) Osaka, Sapporo, Tokyo",
  daylightName: "Tokyo Daylight Time"
}, {
  id: "North Korea Standard Time",
  displayName: "(UTC+09:00) Pyongyang",
  daylightName: "North Korea Daylight Time"
}, {
  id: "Korea Standard Time",
  displayName: "(UTC+09:00) Seoul",
  daylightName: "Korea Daylight Time"
}, {
  id: "Yakutsk Standard Time",
  displayName: "(UTC+09:00) Yakutsk",
  daylightName: "Russia TZ 8 Daylight Time"
}, {
  id: "Cen. Australia Standard Time",
  displayName: "(UTC+09:30) Adelaide",
  daylightName: "Cen. Australia Daylight Time"
}, {
  id: "AUS Central Standard Time",
  displayName: "(UTC+09:30) Darwin",
  daylightName: "AUS Central Daylight Time"
}, {
  id: "E. Australia Standard Time",
  displayName: "(UTC+10:00) Brisbane",
  daylightName: "E. Australia Daylight Time"
}, {
  id: "AUS Eastern Standard Time",
  displayName: "(UTC+10:00) Canberra, Melbourne, Sydney",
  daylightName: "AUS Eastern Daylight Time"
}, {
  id: "West Pacific Standard Time",
  displayName: "(UTC+10:00) Guam, Port Moresby",
  daylightName: "West Pacific Daylight Time"
}, {
  id: "Tasmania Standard Time",
  displayName: "(UTC+10:00) Hobart",
  daylightName: "Tasmania Daylight Time"
}, {
  id: "Vladivostok Standard Time",
  displayName: "(UTC+10:00) Vladivostok",
  daylightName: "Russia TZ 9 Daylight Time"
}, {
  id: "Lord Howe Standard Time",
  displayName: "(UTC+10:30) Lord Howe Island",
  daylightName: "Lord Howe Daylight Time"
}, {
  id: "Bougainville Standard Time",
  displayName: "(UTC+11:00) Bougainville Island",
  daylightName: "Bougainville Daylight Time"
}, {
  id: "Russia Time Zone 10",
  displayName: "(UTC+11:00) Chokurdakh",
  daylightName: "Russia TZ 10 Daylight Time"
}, {
  id: "Magadan Standard Time",
  displayName: "(UTC+11:00) Magadan",
  daylightName: "Magadan Daylight Time"
}, {
  id: "Norfolk Standard Time",
  displayName: "(UTC+11:00) Norfolk Island",
  daylightName: "Norfolk Daylight Time"
}, {
  id: "Sakhalin Standard Time",
  displayName: "(UTC+11:00) Sakhalin",
  daylightName: "Sakhalin Daylight Time"
}, {
  id: "Central Pacific Standard Time",
  displayName: "(UTC+11:00) Solomon Is., New Caledonia",
  daylightName: "Central Pacific Daylight Time"
}, {
  id: "Russia Time Zone 11",
  displayName: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
  daylightName: "Russia TZ 11 Daylight Time"
}, {
  id: "New Zealand Standard Time",
  displayName: "(UTC+12:00) Auckland, Wellington",
  daylightName: "New Zealand Daylight Time"
}, {
  id: "UTC+12",
  displayName: "(UTC+12:00) Coordinated Universal Time+12",
  daylightName: "UTC+12"
}, {
  id: "Fiji Standard Time",
  displayName: "(UTC+12:00) Fiji",
  daylightName: "Fiji Daylight Time"
}, {
  id: "Kamchatka Standard Time",
  displayName: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
  daylightName: "Kamchatka Daylight Time"
}, {
  id: "Chatham Islands Standard Time",
  displayName: "(UTC+12:45) Chatham Islands",
  daylightName: "Chatham Islands Daylight Time"
}, {
  id: "UTC+13",
  displayName: "(UTC+13:00) Coordinated Universal Time+13",
  daylightName: "UTC+13"
}, {
  id: "Tonga Standard Time",
  displayName: "(UTC+13:00) Nuku'alofa",
  daylightName: "Tonga Daylight Time"
}, {
  id: "Samoa Standard Time",
  displayName: "(UTC+13:00) Samoa",
  daylightName: "Samoa Daylight Time"
}, {
  id: "Line Islands Standard Time",
  displayName: "(UTC+14:00) Kiritimati Island",
  daylightName: "Line Islands Daylight Time"
}];
var dataTimeZone = ['Africa/Abidjan', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Asmera', 'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Blantyre', 'Africa/Brazzaville', 'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/Conakry', 'Africa/Dakar', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown', 'Africa/Gaborone', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum', 'Africa/Kigali', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Mogadishu', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou', 'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Timbuktu', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak', 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/ComodRivadavia', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba', 'America/Asuncion', 'America/Atikokan', 'America/Atka', 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise', 'America/Buenos_Aires', 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Catamarca', 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Chihuahua', 'America/Coral_Harbour', 'America/Cordoba', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit', 'America/Dominica', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador', 'America/Ensenada', 'America/Fort_Nelson', 'America/Fort_Wayne', 'America/Fortaleza', 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Grenada', 'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indianapolis', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica', 'America/Jujuy', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Knox_IN', 'America/Kralendijk', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Louisville', 'America/Lower_Princes', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Marigot', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan', 'America/Mendoza', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Montreal', 'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Acre', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Rosario', 'America/Santa_Isabel', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/Shiprock', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto', 'America/Tortola', 'America/Vancouver', 'America/Virgin', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/South_Pole', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Ashkhabad', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Calcutta', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Chongqing', 'Asia/Chungking', 'Asia/Colombo', 'Asia/Dacca', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Harbin', 'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Istanbul', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kashgar', 'Asia/Kathmandu', 'Asia/Katmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Kuwait', 'Asia/Macao', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qyzylorda', 'Asia/Rangoon', 'Asia/Riyadh', 'Asia/Saigon', 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Tel_Aviv', 'Asia/Thimbu', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ujung_Pandang', 'Asia/Ulaanbaatar', 'Asia/Ulan_Bator', 'Asia/Urumqi', 'Asia/Ust-Nera', 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faeroe', 'Atlantic/Faroe', 'Atlantic/Jan_Mayen', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/St_Helena', 'Atlantic/Stanley', 'Australia/ACT', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Canberra', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/LHI', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/NSW', 'Australia/North', 'Australia/Perth', 'Australia/Queensland', 'Australia/South', 'Australia/Sydney', 'Australia/Tasmania', 'Australia/Victoria', 'Australia/West', 'Australia/Yancowinna', 'Brazil/Acre', 'Brazil/DeNoronha', 'Brazil/East', 'Brazil/West', 'CET', 'CST6CDT', 'Canada/Atlantic', 'Canada/Central', 'Canada/Eastern', 'Canada/Mountain', 'Canada/Newfoundland', 'Canada/Pacific', 'Canada/Saskatchewan', 'Canada/Yukon', 'Chile/Continental', 'Chile/EasterIsland', 'Cuba', 'EET', 'EST', 'EST5EDT', 'Egypt', 'Eire', 'Etc/GMT', 'Etc/GMT+0', 'Etc/GMT+1', 'Etc/GMT+10', 'Etc/GMT+11', 'Etc/GMT+12', 'Etc/GMT+2', 'Etc/GMT+3', 'Etc/GMT+4', 'Etc/GMT+5', 'Etc/GMT+6', 'Etc/GMT+7', 'Etc/GMT+8', 'Etc/GMT+9', 'Etc/GMT-0', 'Etc/GMT-1', 'Etc/GMT-10', 'Etc/GMT-11', 'Etc/GMT-12', 'Etc/GMT-13', 'Etc/GMT-14', 'Etc/GMT-2', 'Etc/GMT-3', 'Etc/GMT-4', 'Etc/GMT-5', 'Etc/GMT-6', 'Etc/GMT-7', 'Etc/GMT-8', 'Etc/GMT-9', 'Etc/GMT0', 'Etc/Greenwich', 'Etc/UCT', 'Etc/UTC', 'Etc/Universal', 'Etc/Zulu', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan', 'Europe/Athens', 'Europe/Belfast', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Busingen', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Guernsey', 'Europe/Helsinki', 'Europe/Isle_of_Man', 'Europe/Istanbul', 'Europe/Jersey', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/Ljubljana', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Nicosia', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/San_Marino', 'Europe/Sarajevo', 'Europe/Saratov', 'Europe/Simferopol', 'Europe/Skopje', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Tiraspol', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vaduz', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zaporozhye', 'Europe/Zurich', 'GB', 'GB-Eire', 'GMT', 'GMT+0', 'GMT-0', 'GMT0', 'Greenwich', 'HST', 'Hongkong', 'Iceland', 'Indian/Antananarivo', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Comoro', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Mayotte', 'Indian/Reunion', 'Iran', 'Israel', 'Jamaica', 'Japan', 'Kwajalein', 'Libya', 'MET', 'MST', 'MST7MDT', 'Mexico/BajaNorte', 'Mexico/BajaSur', 'Mexico/General', 'NZ', 'NZ-CHAT', 'Navajo', 'PRC', 'PST8PDT', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Johnston', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Midway', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Ponape', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Saipan', 'Pacific/Samoa', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Truk', 'Pacific/Wake', 'Pacific/Wallis', 'Pacific/Yap', 'Poland', 'Portugal', 'ROC', 'ROK', 'Singapore', 'Turkey', 'UCT', 'US/Alaska', 'US/Aleutian', 'US/Arizona', 'US/Central', 'US/East-Indiana', 'US/Eastern', 'US/Hawaii', 'US/Indiana-Starke', 'US/Michigan', 'US/Mountain', 'US/Pacific', 'US/Pacific-New', 'US/Samoa', 'UTC', 'Universal', 'W-SU', 'WET', 'Zulu'];
var _default = exports["default"] = {
  getTimeZones: getTimeZones
};

},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constant = require("../../common/constant");
var _httpClient = _interopRequireDefault(require("../api/httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var endpoint = "".concat(window.ENV.GENERALCONFIGURATION_ENDPOINT, "/api/configuration-view-template");
function create(data) {
  return _httpClient["default"].post("".concat(endpoint, "/create"), data);
}
function update(data) {
  return _httpClient["default"].put("".concat(endpoint, "/update"), data);
}
function get(id) {
  return _httpClient["default"].get("".concat(endpoint, "/get"), {
    params: {
      id: id
    }
  });
}
function remove(id) {
  return _httpClient["default"]["delete"]("".concat(endpoint, "/delete"), {
    params: {
      id: id
    }
  });
}
function list() {
  var queryObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    length: _constant.API_LIST_ALL_LENGTH
  };
  return _httpClient["default"].post("".concat(endpoint, "/list"), $.param(queryObj), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}
var _default = exports["default"] = {
  create: create,
  update: update,
  get: get,
  remove: remove,
  list: list
};

},{"../../common/constant":4,"../api/httpClient":40}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("../api/httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function resolveFileType(file) {
  var fileName = file.name || "";
  if (fileName.endsWith(".kml")) {
    return "text/xml";
  }
  return "text/plain";
}
function uploadFile(_x) {
  return _uploadFile.apply(this, arguments);
}
function _uploadFile() {
  _uploadFile = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(file) {
    var _yield$httpClient$pos, _yield$httpClient$pos2, fields, url, formData, key;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _httpClient["default"].post("".concat(window.ENV.UPLOAD_FILE_ENDPOINT, "/api/presigned_url"), {
            fileName: file.name,
            contentType: file.type || resolveFileType(file)
          });
        case 2:
          _yield$httpClient$pos = _context.sent;
          _yield$httpClient$pos2 = _yield$httpClient$pos.data;
          fields = _yield$httpClient$pos2.fields;
          url = _yield$httpClient$pos2.url;
          formData = new FormData();
          for (key in fields) {
            formData.append(key, fields[key]);
          }
          formData.append("file", file);
          _context.next = 11;
          return _httpClient["default"].post(url, formData, {
            transformRequest: [function (data, headers) {
              delete headers.Authorization;
              headers["Content-Type"] = "multipart/form-data";
              return data;
            }]
          });
        case 11:
          return _context.abrupt("return", new URL("".concat(url, "/").concat(fields.key)).href);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _uploadFile.apply(this, arguments);
}
function importBeat(_x2) {
  return _importBeat.apply(this, arguments);
}
function _importBeat() {
  _importBeat = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(file) {
    var kmlFileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return uploadFile(file);
        case 2:
          kmlFileName = _context2.sent;
          return _context2.abrupt("return", _httpClient["default"].post("".concat(window.ENV.BEATS_ENDPOINT, "/api/kml/import-beats"), {
            kmlFileName: kmlFileName
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _importBeat.apply(this, arguments);
}
function importQuadrant(_x3) {
  return _importQuadrant.apply(this, arguments);
}
function _importQuadrant() {
  _importQuadrant = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(file) {
    var kmlFileName;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return uploadFile(file);
        case 2:
          kmlFileName = _context3.sent;
          return _context3.abrupt("return", _httpClient["default"].post("".concat(window.ENV.QUADRANTS_ENDPOINT, "/api/kml/import-quadrants"), {
            kmlFileName: kmlFileName
          }));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _importQuadrant.apply(this, arguments);
}
var _default = exports["default"] = {
  importBeat: importBeat,
  importQuadrant: importQuadrant,
  uploadFile: uploadFile
};

},{"../api/httpClient":40}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("./httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var endpoint = "".concat(window.ENV.DATASET_ENDPOINT, "/api/datas");
function listCallTypes(typeId, organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/call-type"), {
    params: {
      typeId: typeId,
      organizationId: organizationId
    }
  });
}
function listUnitTypes(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/unit-type"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listUnitBeats(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/unit-beat"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listUnitStatuses(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/unit-status"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listStations(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/station"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listFdids(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/fdid"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listFilters(filterEnums, organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/view-filter"), {
    params: {
      filterEnums: filterEnums,
      organizationId: organizationId
    }
  });
}
function listCallPriorities(typeId, organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/call-priorities"), {
    params: {
      typeId: typeId,
      organizationId: organizationId
    }
  });
}
function listDispositions(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/dispositions"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listEmds(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/emd"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listOrganizations(query) {
  return _httpClient["default"].get("".concat(endpoint, "/call-organizations"), {
    params: _objectSpread({
      length: 1000000
    }, query)
  });
}
function listCfsBeats(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/cfs-beat-list"), {
    params: {
      organizationId: organizationId
    }
  });
}
function listCfsGrids(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "/cfs-grid-list"), {
    params: {
      organizationId: organizationId
    }
  });
}
var _default = exports["default"] = {
  listCallTypes: listCallTypes,
  listUnitTypes: listUnitTypes,
  listUnitBeats: listUnitBeats,
  listUnitStatuses: listUnitStatuses,
  listStations: listStations,
  listFdids: listFdids,
  listFilters: listFilters,
  listCallPriorities: listCallPriorities,
  listDispositions: listDispositions,
  listEmds: listEmds,
  listOrganizations: listOrganizations,
  listCfsBeats: listCfsBeats,
  listCfsGrids: listCfsGrids
};

},{"./httpClient":40}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("./httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var endpoint = "".concat(window.ENV.GENERALCONFIGURATION_ENDPOINT, "/api");
var ConfigCode = {
  REFRESH_INTERVAL: "TIME_INTERVAL_REFRESH"
};
function getGeneralConfiguration(code) {
  return _httpClient["default"].get("".concat(endpoint, "/general-configuration?code=").concat(code));
}
function getLastUpdatedTime() {
  return getGeneralConfiguration(ConfigCode.REFRESH_INTERVAL);
}
function getMailConfig(data) {
  return _httpClient["default"].get("".concat(endpoint, "/email-configuration"));
}
function updateSMTP(isActive) {
  return _httpClient["default"].post("".concat(endpoint, "/smtp"), {
    active: isActive
  });
}
var _default = exports["default"] = {
  getLastUpdatedTime: getLastUpdatedTime,
  getMailConfig: getMailConfig,
  updateSMTP: updateSMTP
};

},{"./httpClient":40}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constant = require("../../common/constant");
var _httpClient = _interopRequireDefault(require("../api/httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var endpoint = "".concat(window.ENV.GROUP_ENDPOINT, "/api/groups");
function create(data) {
  return _httpClient["default"].post("".concat(endpoint, "/create"), data);
}
function update(data) {
  return _httpClient["default"].put("".concat(endpoint, "/update"), data);
}
function get(id) {
  return _httpClient["default"].get("".concat(endpoint, "/get"), {
    params: {
      id: id
    }
  });
}
function remove(id) {
  return _httpClient["default"]["delete"]("".concat(endpoint, "/delete"), {
    params: {
      id: id
    }
  });
}
function list() {
  var queryObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    length: _constant.API_LIST_ALL_LENGTH
  };
  return _httpClient["default"].post("".concat(endpoint, "/list"), $.param(queryObj), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}
function listByOrganization(organizationId) {
  return _httpClient["default"].get("".concat(endpoint, "-by-organization/get"), {
    params: {
      organizationId: organizationId
    }
  });
}
var _default = exports["default"] = {
  create: create,
  update: update,
  get: get,
  remove: remove,
  list: list,
  listByOrganization: listByOrganization
};

},{"../../common/constant":4,"../api/httpClient":40}],40:[function(require,module,exports){
(function (global){(function (){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _auth = _interopRequireDefault(require("../auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var httpClient = axios.create({
  headers: {
    "Content-Type": "application/json",
    Pragma: "no-cache"
  }
});
httpClient.interceptors.request.use(function (requestConfig) {
  requestConfig.headers.Authorization = _auth["default"].accessToken;
  requestConfig.headers.SocketID = global.SocketClientKey;
  return requestConfig;
});
httpClient.interceptors.response.use(function (response) {
  var _response$data = response.data,
    data = _response$data.data,
    message = _response$data.message;
  return {
    status: response.status,
    data: data,
    message: message
  };
}, function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(error) {
    var _error$response, response, message, errorCode, session, originalRequest;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _error$response = error.response, response = _error$response === void 0 ? {} : _error$response, message = error.message;
          errorCode = response.status;
          if (!(errorCode === 401)) {
            _context.next = 9;
            break;
          }
          _context.next = 5;
          return _auth["default"].refreshSession();
        case 5:
          session = _context.sent;
          if (!session) {
            _context.next = 9;
            break;
          }
          originalRequest = error.config;
          return _context.abrupt("return", httpClient(originalRequest));
        case 9:
          return _context.abrupt("return", Promise.reject({
            status: errorCode,
            message: _.get(response, "data.errorDescription") || _.get(response, "data.message") || message
          }));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var _default = exports["default"] = httpClient;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../auth":48}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("../api/httpClient"));
var _userProfile = _interopRequireDefault(require("../../models/userProfile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var endpoint = "".concat(window.ENV.MASSAGE_ENDPOINT, "/api/messages");
function create(data) {
  data.organizationId && data.organizationId === "null" && delete data.organizationId;
  return _httpClient["default"].post(endpoint, data);
}
function list(queryObject) {
  var startRow = queryObject.startRow,
    length = queryObject.length;
  var newRequestData = {
    page: Math.ceil(startRow / length) + 1,
    limit: length,
    organizationId: _userProfile["default"].organizationId
  };
  return _httpClient["default"].get(endpoint, {
    params: newRequestData
  });
}
var _default = exports["default"] = {
  create: create,
  list: list
};

},{"../../models/userProfile":17,"../api/httpClient":40}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constant = require("../../common/constant");
var _httpClient = _interopRequireDefault(require("../api/httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var endpoint = "".concat(window.ENV.ORGANIZATION_ENDPOINT, "/api/Organizations");
function create(data) {
  return _httpClient["default"].post("".concat(endpoint, "/create"), data);
}
function update(data) {
  return _httpClient["default"].put("".concat(endpoint, "/update"), data);
}
function get(id) {
  return _httpClient["default"].get("".concat(endpoint, "/get"), {
    params: {
      id: id
    }
  });
}
function remove(id) {
  return _httpClient["default"]["delete"]("".concat(endpoint, "/delete"), {
    params: {
      id: id
    }
  });
}
function list() {
  var queryObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    length: _constant.API_LIST_ALL_LENGTH
  };
  return _httpClient["default"].post("".concat(endpoint, "/list"), $.param(queryObj), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}
function resetData(id) {
  return _httpClient["default"]["delete"]("".concat(endpoint, "/reset-cad-data"), {
    params: {
      organizationId: id
    }
  });
}
function authenticatePin(data) {
  return _httpClient["default"].post("".concat(endpoint, "/authenticate-pin"), data);
}
function authenticateUnPin(data) {
  return _httpClient["default"].post("".concat(endpoint, "/authenticate-un-pin"), data);
}
var _default = exports["default"] = {
  create: create,
  update: update,
  get: get,
  remove: remove,
  list: list,
  resetData: resetData,
  authenticatePin: authenticatePin,
  authenticateUnPin: authenticateUnPin
};

},{"../../common/constant":4,"../api/httpClient":40}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var rapidSOSClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  baseURL: window.ENV.RAPID_ENDPOINT
});
function getMapUrl(_x, _x2) {
  return _getMapUrl.apply(this, arguments);
}
function _getMapUrl() {
  _getMapUrl = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(rpNumber, token) {
    var config, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = {
            headers: {
              Authorization: "Bearer ".concat(token)
            }
          };
          _context.next = 3;
          return rapidSOSClient.post("/integrations/irp", {
            query: "tel://".concat(rpNumber)
          }, config);
        case 3:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMapUrl.apply(this, arguments);
}
var _default = exports["default"] = {
  getMapUrl: getMapUrl
};

},{}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("./httpClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var endpoint = "".concat(window.ENV.CFS_ENDPOINT, "/api/report");
function list(_x) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(_ref) {
    var startDate, endDate, organizationId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          startDate = _ref.startDate, endDate = _ref.endDate, organizationId = _ref.organizationId;
          return _context.abrupt("return", _httpClient["default"].get("".concat(endpoint, "/total-cfs-export-with-organization"), {
            params: {
              organizationId: organizationId,
              startDate: startDate,
              endDate: endDate
            }
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
var _default = exports["default"] = {
  list: list
};

},{"./httpClient":40}],45:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("./httpClient"));
var _constant = require("../../common/constant");
var _dataImport = _interopRequireDefault(require("./dataImport"));
var _excluded = ["id"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var endpoint = "".concat(window.ENV.RESOURCES_ENDPOINT, "/api/resources");
function list(request) {
  var isDisplay = request.isDisplay,
    type = request.type;
  return _httpClient["default"].post("".concat(endpoint, "/list"), {
    page: 1,
    limit: _constant.API_LIST_ALL_LENGTH,
    isDisplay: isDisplay,
    type: type
  });
}
function create(_x) {
  return _create.apply(this, arguments);
}
function _create() {
  _create = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(request) {
    var data, name, isDisplay, position, link, type;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = request.data, name = request.name, isDisplay = request.isDisplay, position = request.position;
          if (!(typeof data === "string")) {
            _context.next = 6;
            break;
          }
          type = "link";
          link = data;
          _context.next = 14;
          break;
        case 6:
          if (!(data instanceof File)) {
            _context.next = 13;
            break;
          }
          type = "file";
          _context.next = 10;
          return _dataImport["default"].uploadFile(data);
        case 10:
          link = _context.sent;
          _context.next = 14;
          break;
        case 13:
          throw Error("Invalid resource data");
        case 14:
          return _context.abrupt("return", _httpClient["default"].post("".concat(endpoint, "/create"), {
            isDisplay: isDisplay,
            link: link,
            name: name,
            type: type,
            position: position
          }));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _create.apply(this, arguments);
}
function update(request) {
  var id = request.id,
    others = _objectWithoutProperties(request, _excluded);
  return _httpClient["default"].put("".concat(endpoint, "/").concat(id, "/update"), others);
}
function remove(id) {
  return _httpClient["default"]["delete"]("".concat(endpoint, "/").concat(id, "/delete"));
}
var _default = exports["default"] = {
  list: list,
  create: create,
  remove: remove,
  update: update
};

},{"../../common/constant":4,"./dataImport":36,"./httpClient":40}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _compatibilityHelpers = require("../../common/compatibilityHelpers");
var _httpClient = _interopRequireDefault(require("./httpClient"));
var _userProfile = _interopRequireDefault(require("./../../models/userProfile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var endpoint = "".concat(window.ENV.CFS_ENDPOINT, "/api/units");
var newEndpoint = "".concat(window.ENV.UNIT_ENDPOINT, "/api/units");
var endpointImportContact = "".concat(window.ENV.UNIT_ENDPOINT, "/api/contact/import");
function list(_x) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(params) {
    var _response$data$unitDa;
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _httpClient["default"].get("".concat(endpoint, "/unit-assigned"), {
            params: params
          });
        case 2:
          response = _context.sent;
          (_response$data$unitDa = response.data.unitData) === null || _response$data$unitDa === void 0 || _response$data$unitDa.forEach(function (element) {
            return (0, _compatibilityHelpers.remapField)(element, {
              fdid: "fdidAgency",
              psap: "pSap",
              radioChannel: "radioChanel",
              station: "stationName",
              unitID: "unitId",
              unitFullName: function unitFullName(_ref) {
                var firstName = _ref.firstName,
                  lastName = _ref.lastName;
                return [firstName, lastName].filter(Boolean).join(" ");
              }
            });
          });
          return _context.abrupt("return", response);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
function get(id, organizationId) {
  var params = {
    unitId: id,
    organizationId: organizationId
  };
  _.pickBy(params, _.identity);
  return _httpClient["default"].get("".concat(endpoint, "/get-by-unitId"), {
    params: params
  });
}
function update(unitData) {
  return _httpClient["default"].post("".concat(newEndpoint, "/update"), unitData);
}
function listLog(id) {
  return _httpClient["default"].get("".concat(endpoint, "/get-log-unit-details"), {
    params: {
      id: id
    }
  });
}
function importUnitList(file) {
  var formData = new FormData();
  formData.append("file", file, "CSVFile.csv");
  formData.append("organizationId", _userProfile["default"].organizationId);
  return _httpClient["default"].post("".concat(newEndpoint, "/import-csv-file"), formData, {
    transformRequest: [function (data, headers) {
      headers["Content-Type"] = "application/x-www-form-urlencoded";
      return data;
    }]
  });
}
function importContactUnit(file) {
  var formData = new FormData();
  formData.append("file", file, "CSVFile.csv");
  formData.append("organizationId", _userProfile["default"].organizationId);
  return _httpClient["default"].post("".concat(endpointImportContact), formData, {
    transformRequest: [function (data, headers) {
      headers["Content-Type"] = "application/x-www-form-urlencoded";
      return data;
    }]
  });
}
var _default = exports["default"] = {
  list: list,
  get: get,
  update: update,
  listLog: listLog,
  importUnitList: importUnitList,
  importContactUnit: importContactUnit
};

},{"../../common/compatibilityHelpers":3,"./../../models/userProfile":17,"./httpClient":40}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _httpClient = _interopRequireDefault(require("../api/httpClient"));
var _auth = _interopRequireDefault(require("../auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var endpoint = "".concat(window.ENV.USER_ENDPOINT, "/api/user");
function create(data) {
  return _httpClient["default"].post("".concat(endpoint, "/add"), data);
}
function update(data) {
  return _httpClient["default"].put("".concat(endpoint, "/update"), data);
}
function get(id) {
  return _httpClient["default"].get("".concat(endpoint, "/get"), {
    params: {
      id: id
    }
  });
}
function remove(id) {
  return _httpClient["default"]["delete"]("".concat(endpoint, "/delete"), {
    params: {
      id: id
    }
  });
}
function updatePassword(data) {
  return _httpClient["default"].put("".concat(endpoint, "/update-password"), data);
}
function list(queryObject) {
  var draw = queryObject.draw,
    length = queryObject.length,
    start = queryObject.start,
    order = queryObject.order,
    columns = queryObject.columns;
  var body = {
    filter: columns.reduce(function (acc, _ref) {
      var name = _ref.name,
        search = _ref.search;
      if (name) {
        acc[name] = search.value;
      }
      return acc;
    }, {}),
    order: _defineProperty({}, columns[order[0].column].name, order[0].dir),
    start: start,
    length: length,
    draw: draw
  };
  return _httpClient["default"].post("".concat(endpoint, "/list"), body);
}
function getProfile() {
  return _httpClient["default"].get("".concat(endpoint, "/profile"));
}
function updateActivityStatus() {
  var activityStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Online" | "Offline";
  return _httpClient["default"].put("".concat(endpoint, "/activity-status"), {
    activityStatus: activityStatus
  });
}
function updateStatus(status) {
  if (!_auth["default"].accessToken) return;
  localStorage.setItem('status', "".concat(status, "|").concat(new Date().getTime()));
  var url = "".concat(window.ENV.USER_ENDPOINT, "/api/user/activity-status");
  var xhr = new XMLHttpRequest();
  xhr.open("PUT", url);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("authorization", _auth["default"].accessToken);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      localStorage.setItem('status', "".concat(status, "|").concat(new Date().getTime()));
      if (xhr.status === 401) {
        _auth["default"].refreshSession().then(function () {
          updateStatus(status);
        });
      }
    }
  };
  var data = "{\n  \"activityStatus\": \"".concat(status, "\"\n  }");
  xhr.send(data);
}
var _default = exports["default"] = {
  create: create,
  update: update,
  get: get,
  remove: remove,
  updatePassword: updatePassword,
  list: list,
  getProfile: getProfile,
  updateActivityStatus: updateActivityStatus,
  updateStatus: updateStatus
};

},{"../api/httpClient":40,"../auth":48}],48:[function(require,module,exports){
(function (global){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _navigator = _interopRequireDefault(require("../router/navigator"));
var _user = _interopRequireDefault(require("../services/api/user"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var AwsAmplify = global.aws_amplify["default"];
AwsAmplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: window.ENV.COGNITO_REGION,
    userPoolId: window.ENV.COGNITO_USER_POOL_ID,
    identityPoolId: window.ENV.COGNOITO_IDENTITY_POOL_ID,
    userPoolWebClientId: window.ENV.COGNITO_USER_POOL_WEB_CLIENT_ID
  }
});
var renewalTask;
var accessToken;
function signOut() {
  return _signOut.apply(this, arguments);
}
function _signOut() {
  _signOut = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _user["default"].updateActivityStatus("Offline");
        case 2:
          _context.next = 4;
          return AwsAmplify.Auth.signOut();
        case 4:
          renewalTask = null;
          accessToken = null;
          localStorage.clear();
          _navigator["default"].reset();
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _signOut.apply(this, arguments);
}
function createRenewalTask() {
  return _createRenewalTask.apply(this, arguments);
}
function _createRenewalTask() {
  _createRenewalTask = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var session, idToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return AwsAmplify.Auth.currentSession();
        case 3:
          session = _context2.sent;
          idToken = session.idToken;
          accessToken = idToken.jwtToken;
          return _context2.abrupt("return", session);
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          if (_context2.t0 !== "No current user") {
            signOut();
          }
        case 12:
          _context2.prev = 12;
          renewalTask = null;
          return _context2.finish(12);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9, 12, 15]]);
  }));
  return _createRenewalTask.apply(this, arguments);
}
function refreshSession() {
  if (renewalTask == null) {
    renewalTask = createRenewalTask();
  }
  return renewalTask;
}
function signIn(_x) {
  return _signIn.apply(this, arguments);
}
function _signIn() {
  _signIn = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(_ref) {
    var username, password, user;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          username = _ref.username, password = _ref.password;
          _context3.next = 3;
          return AwsAmplify.Auth.signIn({
            username: username,
            password: password
          });
        case 3:
          user = _context3.sent;
          if (!(user.challengeName === "NEW_PASSWORD_REQUIRED")) {
            _context3.next = 7;
            break;
          }
          _context3.next = 7;
          return AwsAmplify.Auth.completeNewPassword(user, password);
        case 7:
          _context3.next = 9;
          return refreshSession();
        case 9:
          _context3.next = 11;
          return _user["default"].updateActivityStatus("Online");
        case 11:
          _navigator["default"].reset();
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _signIn.apply(this, arguments);
}
var _default = exports["default"] = {
  signIn: signIn,
  signOut: signOut,
  refreshSession: refreshSession,
  get accessToken() {
    return accessToken || "";
  },
  get isSignedIn() {
    return !!accessToken;
  }
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../router/navigator":30,"../services/api/user":47}]},{},[1]);
